<form class="prm-form flex flex-column w-full align-items-stretch">

    <!-- Kompakt Üst Bar -->
    @if (!sadceGoruntuleme && !formModu) {
    <div class="prm-ust-bar">
      <div class="prm-ust-sol">
        <span class="prm-sayac">{{ gosterilecekParametreler.length }}<span class="prm-sayac-ayrac">/</span>{{ parametreler?.length }}</span>
        @if (aramaTerimi) {
          <nz-tag nzColor="blue" [nzMode]="'closeable'" (nzOnClose)="aramaTerimi = ''; aramaTerimiGuncelle('')">
            {{ aramaTerimi }}
          </nz-tag>
        }
      </div>
      <div class="prm-ust-sag">
        @if (!sadceGoruntuleme) {
          <button nz-button nzSize="small" nzType="text" nzShape="circle"
                  [disabled]="!undoYapilabilir" (click)="geriAl()"
                  nz-tooltip nzTooltipTitle="Geri Al (Ctrl+Z)">
            <nz-icon nzType="undo" />
          </button>
          <button nz-button nzSize="small" nzType="text" nzShape="circle"
                  [disabled]="!redoYapilabilir" (click)="ileriAl()"
                  nz-tooltip nzTooltipTitle="İleri Al (Ctrl+Y)">
            <nz-icon nzType="redo" />
          </button>
        }
        <button nz-button nzSize="small" nzType="text" nzShape="circle"
                (click)="gorunumModu = gorunumModu === 'liste' ? 'kart' : 'liste'"
                nz-tooltip [nzTooltipTitle]="gorunumModu === 'liste' ? 'Kart Görünümü' : 'Liste Görünümü'">
          <nz-icon [nzType]="gorunumModu === 'liste' ? 'appstore' : 'bars'" />
        </button>
        <button nz-button nzSize="small" nzType="text" nzShape="circle"
                (click)="toolbarAcik = !toolbarAcik"
                nz-tooltip [nzTooltipTitle]="toolbarAcik ? 'Araçları gizle' : 'Ara & Filtrele'">
          <nz-icon [nzType]="toolbarAcik ? 'up' : 'search'" />
        </button>
        @if (!sadceGoruntuleme) {
          <button nz-button nzSize="small" nzType="text" nzShape="circle"
                  (click)="hizliEkleAcik = !hizliEkleAcik"
                  nz-tooltip nzTooltipTitle="Parametre Ekle">
            <nz-icon [nzType]="hizliEkleAcik ? 'minus' : 'plus'" />
          </button>
        }
        <button nz-button nzSize="small" nzType="text" nzShape="circle"
                nz-popover [nzPopoverContent]="ustBarIslemTpl" nzPopoverTrigger="click"
                nzPopoverPlacement="bottomRight">
          <nz-icon nzType="more" />
        </button>
        <ng-template #ustBarIslemTpl>
          <div class="kart-menu-grid" style="min-width:260px">
            <button class="kart-menu-btn" (click)="tumAyarlariAc()">
              <nz-icon nzType="folder-open" /><span>Ayarları Aç</span>
            </button>
            <button class="kart-menu-btn" (click)="tumAyarlariKapat()">
              <nz-icon nzType="folder" /><span>Ayarları Kapat</span>
            </button>
            <button class="kart-menu-btn" (click)="parametreIceriAktar()">
              <nz-icon nzType="import" /><span>İçe Aktar</span>
            </button>
            <button class="kart-menu-btn" (click)="tumParametreleriDisaAktar()">
              <nz-icon nzType="export" /><span>Dışa Aktar</span>
            </button>
            <button class="kart-menu-btn" (click)="panodanParametreYapistir()">
              <nz-icon nzType="snippets" /><span>Yapıştır</span>
            </button>
            <button class="kart-menu-btn" nz-popconfirm nzPopconfirmTitle="Filtreler temizlensin mi?"
                    nzOkText="Temizle" nzCancelText="Vazgeç" (nzOnConfirm)="gelismisFiltreleriSifirla()">
              <nz-icon nzType="clear" /><span>Filtre Temizle</span>
            </button>
            <button class="kart-menu-btn" (click)="sablonModalAcik = true">
              <nz-icon nzType="save" /><span>Şablon Kaydet</span>
            </button>
            <button class="kart-menu-btn" (click)="sablonModalAcik = true">
              <nz-icon nzType="folder-open" /><span>Şablon Yükle</span>
            </button>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Genişletilebilir Araç Çubuğu -->
    @if (toolbarAcik) {
    <div class="ide-toolbar">
      <div class="ide-toolbar-sol">
        <nz-input-wrapper nzSize="small" [nzPrefix]="''" class="ide-arama-kutu">
          <input nz-input nzSize="small"
                 [(ngModel)]="aramaTerimi"
                 [ngModelOptions]="{standalone: true}"
                 placeholder="Parametrelerde ara..."
                 (ngModelChange)="aramaTerimiGuncelle($event)" />
        </nz-input-wrapper>
        <nz-select nzSize="small" [(ngModel)]="secilenKategori"
                   [ngModelOptions]="{standalone: true}"
                   nzPlaceHolder="Tür"
                   nzAllowClear
                   style="width: 110px;"
                   (ngModelChange)="kategoriyeGoreFiltre($event || 'tum')">
          <nz-option nzValue="tum" nzLabel="Tümü"></nz-option>
          @for (kat of kategoriler; track kat) {
            @if (kat !== 'tum') {
              <nz-option [nzValue]="kat" [nzLabel]="kat"></nz-option>
            }
          }
        </nz-select>
        <button nz-button nzSize="small" [nzType]="gelismisFiltreler.zorunlu ? 'primary' : 'default'"
                (click)="gelismisFiltreler.zorunlu = gelismisFiltreler.zorunlu ? null : true; gelismisFiltreUygula()"
                nz-tooltip nzTooltipTitle="Zorunlu">*</button>
        <button nz-button nzSize="small" [nzType]="gelismisFiltreler.hataliMi ? 'primary' : 'default'" [class.btn-hata]="gelismisFiltreler.hataliMi"
                (click)="gelismisFiltreler.hataliMi = gelismisFiltreler.hataliMi ? null : true; gelismisFiltreUygula()"
                nz-tooltip nzTooltipTitle="Hatalı">
          <nz-icon nzType="warning" />
        </button>
        <button nz-button nzSize="small" [nzType]="gelismisFiltreler.degerliMi === false ? 'primary' : 'default'"
                (click)="gelismisFiltreler.degerliMi = gelismisFiltreler.degerliMi === false ? null : false; gelismisFiltreUygula()"
                nz-tooltip nzTooltipTitle="Boş">
          <nz-icon nzType="file-unknown" />
        </button>
      </div>
    </div>
    }
    }

    @if (!sadceGoruntuleme && !formModu && zorunluIlerleme.toplam > 0) {
      <div class="prm-ilerleme">
        <div class="prm-ilerleme-bar">
          <div class="prm-ilerleme-dolgu" [style.width.%]="zorunluIlerleme.yuzde"
               [class.prm-ilerleme--tamam]="zorunluIlerleme.yuzde === 100"></div>
        </div>
        <span class="prm-ilerleme-metin">{{ zorunluIlerleme.doldurulan }}/{{ zorunluIlerleme.toplam }} zorunlu alan</span>
      </div>
    }

    <!-- Hızlı Parametre Ekleme Paneli -->
    @if (!sadceGoruntuleme && hizliEkleAcik) {
      <parametre-hizli-ekle
        [mevcutIsimler]="getMevcutIsimler()"
        (parametreEklendi)="hizliParametreEklendi($event)"
        (setEklendi)="hazirSetEklendi($event)">
      </parametre-hizli-ekle>
    }

    <!-- Boş Durum -->
    @if (parametreler?.length < 1 || !parametreler) {
      <div class="prm-bos-durum">
        <div class="prm-bos-ikon">
          <nz-icon nzType="database" nzTheme="outline" />
        </div>
        <div class="prm-bos-baslik">Henüz parametre yok</div>
        <div class="prm-bos-aciklama">Yukarıdaki <strong>+</strong> butonuyla hızlıca parametre ekleyebilirsiniz.</div>
      </div>
    }
        <!-- BİLGİ:  Template Olarak Sema Alınıyor -->
        <ng-template #recursiveParametre
                     let-parametreler>

            <!-- BİLGİ:  Sema Sayısına Göre Form Fieldler Döngüye Giriyor -->
            <div cdkDropList
                 [cdkDropListData]="parametreler"
                 (cdkDropListDropped)="parametreSurukBirakti($event)"
                 class="parametre-drop-list">
            <ng-container *ngFor="let itm of parametreler; let i=index; trackBy: trackByParametreIsmi"
                          tabindex="0">
                @if (gorebilirMi(itm)) {
                <div class="parametre-satir mb-2"
                     [cdkDragDisabled]="sadceGoruntuleme || formModu || !duzenleyebilirMi(itm)"
                     cdkDrag
                     [class.ayarlar-acik]="ayarlarAcikMi(i)"
                     [class.prm-duzenlenebilir]="!sadceGoruntuleme && !formModu && duzenleyebilirMi(itm)"
                     [class.prm-form-modu]="formModu"
                     [class.prm-gosterim-modu]="gosterimModu"
                     [class.prm-hata-anim]="hataAnimSatirlar.has(i)">
                    <!-- Gösterim Modu: özel layout türleri -->
                    @if (gosterimModu && (itm.turu === 'Simgeli Başlık')) {
                    <div class="prm-gosterim-baslik-bandi">
                        <i class="{{ itm.degeri?.simge }} icon" style="font-size:18px;color:var(--py-metin-ikincil);"></i>
                        <div>
                            <div class="prm-gosterim-baslik-yazi">{{ itm.degeri?.baslik }}</div>
                            @if (itm.degeri?.altBaslik) {
                                <div class="prm-gosterim-alt-baslik">{{ itm.degeri?.altBaslik }}</div>
                            }
                        </div>
                    </div>
                    } @else if (gosterimModu && (itm.turu === 'Grup')) {
                    <details class="prm-gosterim-grup" open>
                        <summary class="prm-gosterim-grup-baslik">{{ itm.baslik || itm.ismi }}</summary>
                        <div class="prm-gosterim-grup-icerik">
                            <fikoyt-parametreler
                                [(parametreler)]="itm.degeri"
                                [gosterimModu]="true"
                                [formModu]="true"
                                [yetkiModu]="yetkiModu"
                                [kullaniciRolleri]="kullaniciRolleri">
                            </fikoyt-parametreler>
                        </div>
                    </details>
                    } @else if (gosterimModu && (itm.turu === '2liSatır')) {
                    <div class="prm-gosterim-grid-2">
                        <fikoyt-parametreler [parametreler]="[itm.degeri?.solTaraf]" [gosterimModu]="true" [formModu]="true" [yetkiModu]="yetkiModu" [kullaniciRolleri]="kullaniciRolleri"></fikoyt-parametreler>
                        <fikoyt-parametreler [parametreler]="[itm.degeri?.sagTaraf]" [gosterimModu]="true" [formModu]="true" [yetkiModu]="yetkiModu" [kullaniciRolleri]="kullaniciRolleri"></fikoyt-parametreler>
                    </div>
                    } @else if (gosterimModu && (itm.turu === '3lüSatır')) {
                    <div class="prm-gosterim-grid-3">
                        <fikoyt-parametreler [parametreler]="[itm.degeri?.solTaraf]" [gosterimModu]="true" [formModu]="true" [yetkiModu]="yetkiModu" [kullaniciRolleri]="kullaniciRolleri"></fikoyt-parametreler>
                        <fikoyt-parametreler [parametreler]="[itm.degeri?.ortaTaraf]" [gosterimModu]="true" [formModu]="true" [yetkiModu]="yetkiModu" [kullaniciRolleri]="kullaniciRolleri"></fikoyt-parametreler>
                        <fikoyt-parametreler [parametreler]="[itm.degeri?.sagTaraf]" [gosterimModu]="true" [formModu]="true" [yetkiModu]="yetkiModu" [kullaniciRolleri]="kullaniciRolleri"></fikoyt-parametreler>
                    </div>
                    } @else if (gosterimModu && !gosterimDuzenleMi(i)) {
                    <!-- Gösterim Modu: profesyonel tür bazlı render -->
                    <div class="prm-gosterim-satir"
                         [class.prm-gosterim-duzenlenebilir]="duzenleyebilirMi(itm)"
                         (click)="duzenleyebilirMi(itm) && gosterimDuzenleToggle(i)">
                        <div class="prm-g-etiket">
                            {{ itm.baslik || itm.ismi }}
                            @if (itm.ayarlar?.zorunlu) { <span class="prm-g-zorunlu">*</span> }
                        </div>
                        <div class="prm-g-deger">
                            @switch (itm?.turu) {

                                <!-- Yazı -->
                                @case ('Yazı') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-yazi" [title]="itm.degeri">{{ itm.degeri }}</span>
                                    }
                                }

                                <!-- Yazı Alanı -->
                                @case ('Yazı Alanı') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-yazi-alani">{{ itm.degeri }}</span>
                                    }
                                }

                                <!-- Sayı -->
                                @case ('Sayı') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-sayi">{{ itm.degeri }}</span>
                                    }
                                }

                                <!-- Para -->
                                @case ('Para') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-para">
                                            <span class="prm-g-para-tutar">{{ itm.degeri | number:'1.2-2' }}</span>
                                            <span class="prm-g-para-birim">{{ itm.ayarlar?.paraBirimi || '₺' }}</span>
                                        </span>
                                    }
                                }

                                <!-- Tarih -->
                                @case ('Tarih') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-tarih">{{ itm.degeri | date:'dd MMM yyyy' }}</span>
                                    }
                                }

                                <!-- Tarih Saat -->
                                @case ('Tarih Saat') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-tarih">{{ itm.degeri | date:'dd MMM yyyy HH:mm' }}</span>
                                    }
                                }

                                <!-- Saat -->
                                @case ('Saat') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-saat">{{ itm.degeri }}</span>
                                    }
                                }

                                <!-- Onay -->
                                @case ('Onay') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-bool" [class.prm-g-bool-evet]="itm.degeri" [class.prm-g-bool-hayir]="!itm.degeri">
                                            <span class="prm-g-bool-dot"></span>
                                            {{ itm.degeri ? 'Evet' : 'Hayır' }}
                                        </span>
                                    }
                                }

                                <!-- Anahtar -->
                                @case ('Anahtar') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-bool" [class.prm-g-bool-evet]="itm.degeri" [class.prm-g-bool-hayir]="!itm.degeri">
                                            <span class="prm-g-bool-dot"></span>
                                            {{ itm.degeri ? 'Evet' : 'Hayır' }}
                                        </span>
                                    }
                                }

                                <!-- Doğruluk -->
                                @case ('Doğruluk') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <nz-tag class="prm-g-dogruluk"
                                                [nzColor]="itm.degeri === true ? 'success' : itm.degeri === false ? 'error' : 'default'">
                                            @if (itm.degeri === true) {
                                                <span nz-icon nzType="check-circle" nzTheme="fill"></span> Doğru
                                            } @else if (itm.degeri === false) {
                                                <span nz-icon nzType="close-circle" nzTheme="fill"></span> Yanlış
                                            } @else {
                                                <span nz-icon nzType="question-circle" nzTheme="outline"></span> Bilinmiyor
                                            }
                                        </nz-tag>
                                    }
                                }

                                <!-- Renk -->
                                @case ('Renk') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-renk">
                                            <span class="prm-g-renk-kutu" [style.background]="itm.degeri"></span>
                                            <span class="prm-g-renk-hex">{{ itm.degeri }}</span>
                                        </span>
                                    }
                                }

                                <!-- İlerleme Çubuğu -->
                                @case ('İlerleme Çubuğu') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-ilerleme">
                                            <span class="prm-g-ilerleme-bar">
                                                <span class="prm-g-ilerleme-dolu"
                                                      [style.width.%]="itm.degeri"
                                                      [class.prm-g-ilerleme-dusuk]="itm.degeri < 30"
                                                      [class.prm-g-ilerleme-orta]="itm.degeri >= 30 && itm.degeri < 70"
                                                      [class.prm-g-ilerleme-yuksek]="itm.degeri >= 70"></span>
                                            </span>
                                            <span class="prm-g-ilerleme-yuzde">%{{ itm.degeri }}</span>
                                        </span>
                                    }
                                }

                                <!-- Açılır Kutu -->
                                @case ('Açılır Kutu') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else if (itm?.ayarlar?.itemSablon?.aktif) {
                                        @let secili = acilirKutuSeciliSecenek(itm);
                                        <span class="aku-item aku-item-inline">
                                          @if (itm.ayarlar.itemSablon.renkGoster && secili?.renk) {
                                            <span class="aku-renk" [style.background]="secili.renk"></span>
                                          }
                                          @if (itm.ayarlar.itemSablon.simgeGoster && secili?.simge) {
                                            <span class="aku-simge">{{ secili.simge }}</span>
                                          }
                                          @if (itm.ayarlar.itemSablon.resimGoster && secili?.resimUrl) {
                                            <img class="aku-resim" [src]="secili.resimUrl" loading="lazy" />
                                          }
                                          <nz-tag class="prm-g-chip" [nzColor]="secili?.renk || 'blue'">{{ secili?.label || itm.degeri }}</nz-tag>
                                        </span>
                                    } @else {
                                        <nz-tag class="prm-g-chip" nzColor="blue">{{ itm.degeri }}</nz-tag>
                                    }
                                }

                                <!-- Resim -->
                                @case ('Resim') {
                                    @if (itm.degeri == null || itm.degeri === '' || !itm.degeri?.objectUrl) {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <img class="prm-g-thumbnail" [src]="itm.degeri.objectUrl" alt="Resim" loading="lazy" />
                                    }
                                }

                                <!-- Dosya -->
                                @case ('Dosya') {
                                    @if (itm.degeri == null || itm.degeri === '' || !itm.degeri?.dosya) {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-dosya">
                                            <span nz-icon nzType="paper-clip" nzTheme="outline"></span>
                                            <span class="prm-g-dosya-isim">{{ itm.degeri.dosya.name }}</span>
                                            @if (itm.degeri.dosya.size) {
                                                <span class="prm-g-dosya-boyut">({{ (itm.degeri.dosya.size / 1024) | number:'1.0-1' }} KB)</span>
                                            }
                                        </span>
                                    }
                                }

                                <!-- Konum -->
                                @case ('Konum') {
                                    @if (itm.degeri == null || itm.degeri === '' || itm.degeri?.enlem == null) {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-konum">
                                            <span class="prm-g-konum-pin">&#x1F4CD;</span>
                                            <span class="prm-g-konum-koordinat">{{ itm.degeri.enlem?.toFixed(5) }}, {{ itm.degeri.boylam?.toFixed(5) }}</span>
                                        </span>
                                    }
                                }

                                <!-- XYZ -->
                                @case ('XYZ') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-xyz">
                                            <nz-tag class="prm-g-xyz-x" nzColor="red">X: {{ itm.degeri.x }}</nz-tag>
                                            <nz-tag class="prm-g-xyz-y" nzColor="green">Y: {{ itm.degeri.y }}</nz-tag>
                                            <nz-tag class="prm-g-xyz-z" nzColor="blue">Z: {{ itm.degeri.z }}</nz-tag>
                                        </span>
                                    }
                                }

                                <!-- Liste -->
                                @case ('Liste') {
                                    @if (itm.degeri == null || itm.degeri === '' || !itm.degeri?.length) {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-liste">
                                            @for (eleman of itm.degeri; track $index) {
                                                <nz-tag>{{ eleman }}</nz-tag>
                                            }
                                        </span>
                                    }
                                }

                                <!-- Kod -->
                                @case ('Kod') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <pre class="prm-g-kod">{{ itm.degeri }}</pre>
                                    }
                                }

                                <!-- KareKod -->
                                @case ('KareKod') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <nz-tag class="prm-g-karekod" nzColor="purple">
                                            <span nz-icon nzType="qrcode" nzTheme="outline"></span>
                                            <span>{{ itm.degeri }}</span>
                                        </nz-tag>
                                    }
                                }

                                <!-- BarKod -->
                                @case ('BarKod') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <nz-tag class="prm-g-barkod" nzColor="orange">
                                            <span nz-icon nzType="barcode" nzTheme="outline"></span>
                                            <span class="prm-g-barkod-deger">{{ itm.degeri }}</span>
                                        </nz-tag>
                                    }
                                }

                                <!-- Zaman Aralığı -->
                                @case ('Zaman Aralığı') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-zaman-aralik">
                                            <span class="prm-g-zaman-baslangic">{{ itm.degeri.baslangic | date:'dd MMM yyyy' }}</span>
                                            <span class="prm-g-zaman-ayrac">&mdash;</span>
                                            <span class="prm-g-zaman-bitis">{{ itm.degeri.bitis | date:'dd MMM yyyy' }}</span>
                                        </span>
                                    }
                                }

                                <!-- İmza -->
                                @case ('İmza') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <img class="prm-g-imza" [src]="itm.degeri" alt="İmza" loading="lazy" />
                                    }
                                }

                                <!-- RichText -->
                                @case ('RichText') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <div class="prm-g-richtext" [innerHTML]="itm.degeri"></div>
                                    }
                                }

                                <!-- Oylama -->
                                @case ('Oylama') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <nz-tag nzColor="processing">{{ itm.degeri }}</nz-tag>
                                    }
                                }

                                <!-- Otomatik Kod -->
                                @case ('Otomatik Kod') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Otomatik üretilecek</span>
                                    } @else {
                                        <nz-tag class="prm-g-barkod" nzColor="geekblue">
                                            <span nz-icon nzType="number" nzTheme="outline"></span>
                                            <span class="prm-g-barkod-deger">{{ itm.degeri }}</span>
                                        </nz-tag>
                                    }
                                }

                                @case ('Dinamik Bileşen') {
                                    <dinamik-bilesen
                                        [bilesenId]="itm.ayarlar?.bilesenId"
                                        [gorunum]="itm.ayarlar?.gorunum || 'parametre'"
                                        [(parametreler)]="itm.degeri"
                                    />
                                }

                                @case ('Dosya Kutusu') {
                                    <dosya-kutusu [(deger)]="itm.degeri" [ayarlar]="itm.ayarlar" [sadeceOkunur]="true" />
                                }

                                @case ('Parola') {
                                    <span class="prm-g-parola">&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</span>
                                }

                                @case ('Ay') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Bos</span>
                                    } @else {
                                        <span class="prm-g-tarih">{{ itm.degeri | date:'MMMM yyyy' }}</span>
                                    }
                                }

                                @case ('Hafta') {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Bos</span>
                                    } @else {
                                        <span class="prm-g-tarih">{{ itm.degeri }}</span>
                                    }
                                }

                                @case ('Video') {
                                    @if (itm.degeri == null || itm.degeri === '' || !itm.degeri?.objectUrl) {
                                        <span class="prm-g-bos">Bos</span>
                                    } @else {
                                        <span class="prm-g-dosya">
                                            <span nz-icon nzType="play-circle" nzTheme="outline"></span>
                                            <span class="prm-g-dosya-isim">{{ itm.degeri.dosya?.name }}</span>
                                        </span>
                                    }
                                }

                                @case ('Ses') {
                                    @if (itm.degeri == null || itm.degeri === '' || !itm.degeri?.objectUrl) {
                                        <span class="prm-g-bos">Bos</span>
                                    } @else {
                                        <span class="prm-g-dosya">
                                            <span nz-icon nzType="sound" nzTheme="outline"></span>
                                            <span class="prm-g-dosya-isim">{{ itm.degeri.dosya?.name }}</span>
                                        </span>
                                    }
                                }

                                @case ('Sekme') {
                                    @if (itm.degeri == null || !itm.degeri?.length) {
                                        <span class="prm-g-bos">Bos</span>
                                    } @else {
                                        <span class="prm-g-liste">
                                            @for (tab of itm.degeri; track $index) {
                                                <nz-tag>{{ tab.baslik }}</nz-tag>
                                            }
                                        </span>
                                    }
                                }

                                @case ('Tablo') {
                                    @if (itm.degeri == null || !itm.degeri?.satirlar?.length) {
                                        <span class="prm-g-bos">Bos</span>
                                    } @else {
                                        <span class="prm-g-liste">
                                            <nz-tag nzColor="processing">{{ itm.degeri.satirlar.length }} satir, {{ (itm.degeri.kolonlar ?? itm?.ayarlar?.kolonlar ?? []).length }} kolon</nz-tag>
                                        </span>
                                    }
                                }

                                @case ('Grup') {
                                    @if (itm.degeri == null || !itm.degeri?.length) {
                                        <span class="prm-g-bos">Bos</span>
                                    } @else {
                                        <nz-tag nzColor="default">Grup: {{ itm.degeri.length }} parametre</nz-tag>
                                    }
                                }

                                <!-- Varsayilan -->
                                @default {
                                    @if (itm.degeri == null || itm.degeri === '') {
                                        <span class="prm-g-bos">Boş</span>
                                    } @else {
                                        <span class="prm-g-varsayilan">{{ itm.degeri }}</span>
                                    }
                                }
                            }
                        </div>
                    </div>
                    } @else {
                    <!-- Sürükleme placeholder -->
                    @if (!formModu) {
                    <div class="parametre-drag-placeholder" *cdkDragPlaceholder></div>
                    }

                    <!-- Düzenlenebilir: başlık barı + araçlar -->
                    @if (!sadceGoruntuleme && !formModu && duzenleyebilirMi(itm)) {
                    <div class="parametre-baslik-bar">
                        <div class="baslik-sol">
                            <span class="surukleme-tutamac" cdkDragHandle>
                                <nz-icon nzType="holder" />
                            </span>
                            <span class="parametre-baslik-yazi">{{ itm?.baslik ?? "" }}</span>
                            @if (itm?.ayarlar?.zorunlu) {
                              <span class="zorunlu-isaret">*</span>
                            }
                        </div>
                        <div class="baslik-sag">
                            <button nz-button nzSize="small" nzType="text" nzShape="circle"
                                    (click)="ayarModalAc(itm)"
                                    nz-tooltip nzTooltipTitle="Ayarlar"
                                    class="prm-ayar-btn">
                                <nz-icon nzType="setting" />
                            </button>
                            <button nz-button nzSize="small" nzType="text" nzShape="circle"
                                    nz-popover [nzPopoverContent]="prmIslemTpl" nzPopoverTrigger="click"
                                    nzPopoverPlacement="bottomRight"
                                    class="prm-daha-btn">
                                <nz-icon nzType="more" />
                            </button>
                            <ng-template #prmIslemTpl>
                              <div class="kart-menu-grid" style="min-width:200px">
                                <button class="kart-menu-btn" (click)="ayarModalAc(itm)">
                                  <nz-icon nzType="setting" /><span>Ayarlar</span>
                                </button>
                                <button class="kart-menu-btn" (click)="parametreKopyala(i)">
                                  <nz-icon nzType="copy" /><span>Kopyala</span>
                                </button>
                                <button class="kart-menu-btn" (click)="jsonGorunumToggle(i)">
                                  <nz-icon nzType="code" /><span>JSON</span>
                                </button>
                                <button class="kart-menu-btn" (click)="parametreDisaAktarTekil(itm)">
                                  <nz-icon nzType="export" /><span>Dışa Aktar</span>
                                </button>
                                @if (silebilirMi(itm)) {
                                  <button class="kart-menu-btn kart-menu-btn--tehlike"
                                          nz-popconfirm nzPopconfirmTitle="Bu parametre silinecek. Emin misiniz?"
                                          nzOkText="Sil" nzCancelText="Vazgeç" nzOkDanger nzPopconfirmPlacement="left"
                                          (nzOnConfirm)="tiklandiParametreSil(i)">
                                    <nz-icon nzType="delete" /><span>Sil</span>
                                  </button>
                                }
                              </div>
                            </ng-template>
                        </div>
                    </div>
                    }

                    <!-- Gelismis Ayarlar Paneli -->
                    @if (ayarlarAcikMi(i) && !sadceGoruntuleme) {
                    <div class="gelismis-ayarlar-panel">
                      <nz-tabs nzSize="small" nzType="card" nzAnimated>

                        <!-- GENEL AYARLAR -->
                        <nz-tab nzTitle="Genel">
                          <div class="ayar-grup">
                            <!-- Tür Değiştirici -->
                            <div class="ayar-alan">
                              <span class="ayar-etiket">Parametre Türü</span>
                              <nz-select nzSize="small" [(ngModel)]="itm.turu"
                                         [ngModelOptions]="{standalone: true}"
                                         nzShowSearch
                                         nzPlaceHolder="Tür seçin"
                                         (ngModelChange)="turDegistir(itm, $event)">
                                @for (tur of tumTurler; track tur) {
                                  <nz-option [nzValue]="tur" [nzLabel]="getParametreIkonu(tur) + ' ' + tur"></nz-option>
                                }
                              </nz-select>
                            </div>

                            <div class="ayar-satir-flags">
                              <label nz-checkbox [(ngModel)]="itm.ayarlar.zorunlu"
                                     [ngModelOptions]="{standalone: true}"
                                     (ngModelChange)="inlineAyarDegisti()">Zorunlu</label>
                              <label nz-checkbox [(ngModel)]="itm.ayarlar.sadeceOkunur"
                                     [ngModelOptions]="{standalone: true}"
                                     (ngModelChange)="inlineAyarDegisti()">Salt Okunur</label>
                              <label nz-checkbox [(ngModel)]="itm.ayarlar.gorunur"
                                     [ngModelOptions]="{standalone: true}"
                                     (ngModelChange)="inlineAyarDegisti()">Görünür</label>
                            </div>

                            <div class="ayar-grid-2">
                              <div class="ayar-alan">
                                <span class="ayar-etiket">Başlık</span>
                                <input nz-input nzSize="small" [(ngModel)]="itm.baslik"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="Parametre başlığı"
                                       (ngModelChange)="inlineAyarDegisti()" />
                              </div>
                              <div class="ayar-alan">
                                <span class="ayar-etiket">Teknik İsim</span>
                                <input nz-input nzSize="small" [(ngModel)]="itm.ismi"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="parametre_ismi"
                                       class="kod-alani-inline"
                                       (ngModelChange)="inlineAyarDegisti()" />
                              </div>
                            </div>

                            <div class="ayar-alan">
                              <span class="ayar-etiket">Alt Açıklama</span>
                              <input nz-input nzSize="small" [(ngModel)]="itm.altAciklama"
                                     [ngModelOptions]="{standalone: true}"
                                     placeholder="Kullanıcıya gösterilecek açıklama"
                                     (ngModelChange)="inlineAyarDegisti()" />
                            </div>

                            <div class="ayar-grid-2">
                              <div class="ayar-alan">
                                <span class="ayar-etiket">İpucu (Tooltip)</span>
                                <input nz-input nzSize="small" [(ngModel)]="itm.ipucu"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="Tooltip metni"
                                       (ngModelChange)="inlineAyarDegisti()" />
                              </div>
                              <div class="ayar-alan">
                                <span class="ayar-etiket">Yer Tutucu</span>
                                <input nz-input nzSize="small" [(ngModel)]="itm.yerTutucu"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="Placeholder metin"
                                       (ngModelChange)="inlineAyarDegisti()" />
                              </div>
                            </div>

                            <div class="ayar-alan">
                              <span class="ayar-etiket">Sol Simge</span>
                              <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.solSimge"
                                     [ngModelOptions]="{standalone: true}"
                                     placeholder="Simge (emoji veya ikon sınıfı)"
                                     (ngModelChange)="inlineAyarDegisti()" />
                            </div>
                          </div>
                        </nz-tab>

                        <!-- KISITLAMA AYARLARI -->
                        <nz-tab nzTitle="Kisitlama">
                          <div class="ayar-grup">
                            <div class="ayar-grid-3">
                              <div class="ayar-alan">
                                <span class="ayar-etiket">Min</span>
                                <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.min"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()" />
                              </div>
                              <div class="ayar-alan">
                                <span class="ayar-etiket">Maks</span>
                                <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.maks"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()" />
                              </div>
                              <div class="ayar-alan">
                                <span class="ayar-etiket">Adim</span>
                                <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.adim"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()" />
                              </div>
                            </div>

                            <div class="ayar-alan">
                              <span class="ayar-etiket">Format</span>
                              <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.format"
                                     [ngModelOptions]="{standalone: true}"
                                     placeholder="Orn: dd.MM.yyyy, #.##"
                                     (ngModelChange)="inlineAyarDegisti()" />
                            </div>

                            @if (itm.turu === 'Resim' || itm.turu === 'Video' || itm.turu === 'Ses' || itm.turu === 'Dosya' || itm.turu === 'Dosya Yükleme') {
                              <div class="ayar-alan">
                                <span class="ayar-etiket">Maks Dosya Boyutu (MB)</span>
                                <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.maksBoyutMb"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="10"
                                       (ngModelChange)="inlineAyarDegisti()" />
                              </div>
                            }
                          </div>
                        </nz-tab>

                        <!-- TURE OZEL AYARLAR -->
                        <nz-tab nzTitle="Ture Ozel">
                          <div class="ayar-grup">

                            <!-- Yazı Alanı -->
                            @if (itm.turu === 'Yazı Alanı') {
                              <div class="ayar-alan">
                                <span class="ayar-etiket">Satir Sayisi</span>
                                <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.satirSayisi"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="3"
                                       (ngModelChange)="inlineAyarDegisti()" />
                              </div>
                            }

                            <!-- Açılır Kutu -->
                            @if (itm.turu === 'Açılır Kutu') {
                              <div class="ayar-satir-flags">
                                <label nz-checkbox [(ngModel)]="itm.ayarlar.arama"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()">Aranabilir</label>
                                <label nz-checkbox [(ngModel)]="itm.ayarlar.coklu"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()">Coklu Secim</label>
                                <label nz-checkbox [(ngModel)]="itm.ayarlar.silme"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()">Temizlenebilir</label>
                              </div>

                              <!-- Item Şablon Ayarları -->
                              <div class="ayar-alan">
                                <div class="ayar-etiket-satir">
                                  <span class="ayar-etiket">Özel Item Tasarımı</span>
                                  <label nz-checkbox [ngModel]="!!itm.ayarlar?.itemSablon?.aktif"
                                         [ngModelOptions]="{standalone: true}"
                                         (ngModelChange)="itemSablonToggle(itm)"></label>
                                </div>
                                @if (itm.ayarlar?.itemSablon?.aktif) {
                                  <div class="ayar-satir-flags">
                                    <label nz-checkbox [(ngModel)]="itm.ayarlar.itemSablon.simgeGoster"
                                           [ngModelOptions]="{standalone: true}"
                                           (ngModelChange)="inlineAyarDegisti()">Simge</label>
                                    <label nz-checkbox [(ngModel)]="itm.ayarlar.itemSablon.renkGoster"
                                           [ngModelOptions]="{standalone: true}"
                                           (ngModelChange)="inlineAyarDegisti()">Renk</label>
                                    <label nz-checkbox [(ngModel)]="itm.ayarlar.itemSablon.aciklamaGoster"
                                           [ngModelOptions]="{standalone: true}"
                                           (ngModelChange)="inlineAyarDegisti()">Açıklama</label>
                                    <label nz-checkbox [(ngModel)]="itm.ayarlar.itemSablon.resimGoster"
                                           [ngModelOptions]="{standalone: true}"
                                           (ngModelChange)="inlineAyarDegisti()">Resim</label>
                                  </div>
                                }
                              </div>

                              <!-- Statik Secenekler -->
                              <div class="ayar-alan">
                                <div class="ayar-etiket-satir">
                                  <span class="ayar-etiket">Secenekler</span>
                                  <button nz-button nzSize="small" nzType="dashed"
                                          (click)="inlineSecenekEkle(itm, 'acilirKutu')">+ Ekle</button>
                                </div>
                                @for (s of itm.ayarlar?.secenekler ?? []; track $index) {
                                  <div class="secenek-satir">
                                    <input nz-input nzSize="small" [(ngModel)]="s.label"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Etiket"
                                           (ngModelChange)="inlineAyarDegisti()" />
                                    <input nz-input nzSize="small" [(ngModel)]="s.value"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Deger"
                                           (ngModelChange)="inlineAyarDegisti()" />
                                    @if (itm.ayarlar?.itemSablon?.aktif) {
                                      @if (itm.ayarlar.itemSablon.simgeGoster) {
                                        <input nz-input nzSize="small" [(ngModel)]="s.simge"
                                               [ngModelOptions]="{standalone: true}"
                                               placeholder="🔵"
                                               style="width: 48px; text-align: center;"
                                               (ngModelChange)="inlineAyarDegisti()" />
                                      }
                                      @if (itm.ayarlar.itemSablon.renkGoster) {
                                        <input nz-input nzSize="small" type="color" [(ngModel)]="s.renk"
                                               [ngModelOptions]="{standalone: true}"
                                               style="width: 36px; padding: 1px;"
                                               (ngModelChange)="inlineAyarDegisti()" />
                                      }
                                      @if (itm.ayarlar.itemSablon.aciklamaGoster) {
                                        <input nz-input nzSize="small" [(ngModel)]="s.aciklama"
                                               [ngModelOptions]="{standalone: true}"
                                               placeholder="Açıklama"
                                               (ngModelChange)="inlineAyarDegisti()" />
                                      }
                                      @if (itm.ayarlar.itemSablon.resimGoster) {
                                        <input nz-input nzSize="small" [(ngModel)]="s.resimUrl"
                                               [ngModelOptions]="{standalone: true}"
                                               placeholder="Resim URL"
                                               (ngModelChange)="inlineAyarDegisti()" />
                                      }
                                    }
                                    <button nz-button nzSize="small" nzType="text" nzDanger
                                            (click)="inlineSecenekSil(itm, $index)">
                                      <nz-icon nzType="delete" />
                                    </button>
                                  </div>
                                }
                              </div>

                              <!-- FAPI (Sunucu API) -->
                              <div class="ayar-alan">
                                <label nz-checkbox [ngModel]="!!itm.ayarlar?.fapiAyarlar"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineFapiToggle(itm)">Sunucu API (FAPI)</label>
                                @if (itm.ayarlar?.fapiAyarlar) {
                                  <div class="ayar-grid-2" style="margin-top: 6px;">
                                    <div class="ayar-alan">
                                      <span class="ayar-etiket">VT</span>
                                      <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.fapiAyarlar.vt"
                                             [ngModelOptions]="{standalone: true}"
                                             placeholder="FikoYT.Uyar.firmalar"
                                             (ngModelChange)="inlineAyarDegisti()" />
                                    </div>
                                    <div class="ayar-alan">
                                      <span class="ayar-etiket">Yol</span>
                                      <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.fapiAyarlar.yol"
                                             [ngModelOptions]="{standalone: true}"
                                             placeholder="FikoYT.Uyar.firmalar.kalem"
                                             (ngModelChange)="inlineAyarDegisti()" />
                                    </div>
                                  </div>
                                  <div class="ayar-alan" style="margin-top: 6px;">
                                    <span class="ayar-etiket">Pipe Fonksiyonu</span>
                                    <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.fapiAyarlar.pipeFunc"
                                              [ngModelOptions]="{standalone: true}"
                                              rows="3"
                                              class="kod-alani"
                                              placeholder="return [ { $match: { ... } } ];"
                                              (ngModelChange)="inlineAyarDegisti()"></textarea>
                                  </div>
                                  <div class="ayar-alan" style="margin-top: 6px;">
                                    <span class="ayar-etiket">Secenek Item Fonksiyonu</span>
                                    <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.secenekItm"
                                              [ngModelOptions]="{standalone: true}"
                                              rows="2"
                                              class="kod-alani"
                                              placeholder="return { label: scnk.veri?.ismi, value: scnk._id };"
                                              (ngModelChange)="inlineAyarDegisti()"></textarea>
                                  </div>
                                }
                              </div>
                            }

                            <!-- Renk -->
                            @if (itm.turu === 'Renk') {
                              <div class="ayar-alan">
                                <span class="ayar-etiket">Renk Formati</span>
                                <nz-select nzSize="small" [(ngModel)]="itm.ayarlar.format"
                                           [ngModelOptions]="{standalone: true}"
                                           nzPlaceHolder="Format sec"
                                           (ngModelChange)="inlineAyarDegisti()">
                                  <nz-option nzValue="hex" nzLabel="HEX (#FF0000)"></nz-option>
                                  <nz-option nzValue="rgb" nzLabel="RGB"></nz-option>
                                  <nz-option nzValue="rgba" nzLabel="RGBA"></nz-option>
                                  <nz-option nzValue="hsl" nzLabel="HSL"></nz-option>
                                </nz-select>
                              </div>
                              <label nz-checkbox [(ngModel)]="itm.ayarlar.seffaf"
                                     [ngModelOptions]="{standalone: true}"
                                     (ngModelChange)="inlineAyarDegisti()">Seffaflik Destegi</label>
                            }

                            <!-- İlerleme Çubuğu -->
                            @if (itm.turu === 'İlerleme Çubuğu') {
                              <div class="ayar-satir-flags">
                                <label nz-checkbox [(ngModel)]="itm.ayarlar.yuzdeGoster"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()">Yuzde Goster</label>
                                <label nz-checkbox [(ngModel)]="itm.ayarlar.animasyon"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()">Animasyon</label>
                              </div>
                              <div class="ayar-grid-2">
                                <div class="ayar-alan">
                                  <span class="ayar-etiket">Cubuk Rengi</span>
                                  <input nz-input nzSize="small" type="color" [(ngModel)]="itm.ayarlar.renk"
                                         [ngModelOptions]="{standalone: true}"
                                         (ngModelChange)="inlineAyarDegisti()" />
                                </div>
                                <div class="ayar-alan">
                                  <span class="ayar-etiket">Arka Plan Rengi</span>
                                  <input nz-input nzSize="small" type="color" [(ngModel)]="itm.ayarlar.arkaPlanRenk"
                                         [ngModelOptions]="{standalone: true}"
                                         (ngModelChange)="inlineAyarDegisti()" />
                                </div>
                              </div>
                            }

                            <!-- Oylama -->
                            @if (itm.turu === 'Oylama') {
                              <div class="ayar-satir-flags">
                                <label nz-checkbox [(ngModel)]="itm.ayarlar.anonim"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()">Anonim</label>
                                <label nz-checkbox [(ngModel)]="itm.ayarlar.sonuclarGorunur"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()">Sonuclar Gorunur</label>
                                <label nz-checkbox [(ngModel)]="itm.ayarlar.birdenFazlaSecim"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()">Birden Fazla Secim</label>
                              </div>
                              <div class="ayar-alan">
                                <div class="ayar-etiket-satir">
                                  <span class="ayar-etiket">Secenekler</span>
                                  <button nz-button nzSize="small" nzType="dashed"
                                          (click)="inlineSecenekEkle(itm, 'oylama')">+ Ekle</button>
                                </div>
                                @for (s of itm.ayarlar?.secenekler ?? []; track $index) {
                                  <div class="secenek-satir">
                                    <input nz-input nzSize="small" [(ngModel)]="s.etiket"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Etiket"
                                           (ngModelChange)="inlineAyarDegisti()" />
                                    <input nz-input nzSize="small" [(ngModel)]="s.deger"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Deger"
                                           (ngModelChange)="inlineAyarDegisti()" />
                                    <input nz-input nzSize="small" type="color" [(ngModel)]="s.renk"
                                           [ngModelOptions]="{standalone: true}"
                                           style="width: 40px; padding: 0;"
                                           (ngModelChange)="inlineAyarDegisti()" />
                                    <button nz-button nzSize="small" nzType="text" nzDanger
                                            (click)="inlineSecenekSil(itm, $index)">
                                      <nz-icon nzType="delete" />
                                    </button>
                                  </div>
                                }
                              </div>
                            }

                            <!-- Konum -->
                            @if (itm.turu === 'Konum') {
                              <div class="ayar-grid-2">
                                <div class="ayar-alan">
                                  <span class="ayar-etiket">Zoom Seviyesi</span>
                                  <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.zoom"
                                         [ngModelOptions]="{standalone: true}"
                                         placeholder="15"
                                         (ngModelChange)="inlineAyarDegisti()" />
                                </div>
                                <div class="ayar-alan">
                                  <span class="ayar-etiket">Harita Turu</span>
                                  <nz-select nzSize="small" [(ngModel)]="itm.ayarlar.haritaTuru"
                                             [ngModelOptions]="{standalone: true}"
                                             nzPlaceHolder="Sec"
                                             (ngModelChange)="inlineAyarDegisti()">
                                    <nz-option nzValue="standart" nzLabel="Standart"></nz-option>
                                    <nz-option nzValue="uydu" nzLabel="Uydu"></nz-option>
                                    <nz-option nzValue="hibrit" nzLabel="Hibrit"></nz-option>
                                  </nz-select>
                                </div>
                              </div>
                              <label nz-checkbox [(ngModel)]="itm.ayarlar.otomatikKonum"
                                     [ngModelOptions]="{standalone: true}"
                                     (ngModelChange)="inlineAyarDegisti()">Otomatik Konum Al</label>
                            }

                            <!-- Zaman Aralığı -->
                            @if (itm.turu === 'Zaman Aralığı') {
                              <div class="ayar-alan">
                                <span class="ayar-etiket">Tarih Formati</span>
                                <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.tarihFormat"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="dd.MM.yyyy"
                                       (ngModelChange)="inlineAyarDegisti()" />
                              </div>
                            }

                            <!-- Sekme -->
                            @if (itm.turu === 'Sekme') {
                              <label nz-checkbox [(ngModel)]="itm.ayarlar.jsonGrup"
                                     [ngModelOptions]="{standalone: true}"
                                     (ngModelChange)="inlineAyarDegisti()">JSON Gruplama</label>
                            }

                            <!-- Resim / Video / Ses / Dosya / Dosya Yükleme / Sürükle Bırak -->
                            @if (itm.turu === 'Resim' || itm.turu === 'Video' || itm.turu === 'Ses' || itm.turu === 'Dosya' || itm.turu === 'Dosya Yükleme' || itm.turu === 'Sürükle Bırak') {
                              <div class="ayar-grid-2">
                                <div class="ayar-alan">
                                  <span class="ayar-etiket">Maks Boyut (MB)</span>
                                  <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.maksBoyutMb"
                                         [ngModelOptions]="{standalone: true}"
                                         placeholder="10"
                                         (ngModelChange)="inlineAyarDegisti()" />
                                </div>
                                <div class="ayar-alan">
                                  <span class="ayar-etiket">Kabul Tipleri</span>
                                  <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.accept"
                                         [ngModelOptions]="{standalone: true}"
                                         placeholder="image/*,video/*,.pdf"
                                         (ngModelChange)="inlineAyarDegisti()" />
                                </div>
                              </div>
                            }

                            <!-- XYZ -->
                            @if (itm.turu === 'XYZ') {
                              <div class="ayar-bilgi">
                                <nz-tag nzColor="cyan">X, Y, Z koordinat alanları</nz-tag>
                                <span class="ayar-bilgi-metin">Min/Maks değerlerini Kısıtlama sekmesinden ayarlayın.</span>
                              </div>
                            }

                            <!-- Para -->
                            @if (itm.turu === 'Para') {
                              <div class="ayar-alan">
                                <span class="ayar-etiket">Para Birimi</span>
                                <nz-select nzSize="small" [(ngModel)]="itm.ayarlar.paraBirimi"
                                           [ngModelOptions]="{standalone: true}"
                                           nzPlaceHolder="Para birimi seç"
                                           nzShowSearch
                                           (ngModelChange)="inlineAyarDegisti()">
                                  <nz-option nzValue="TRY" nzLabel="₺ TRY - Türk Lirası"></nz-option>
                                  <nz-option nzValue="USD" nzLabel="$ USD - ABD Doları"></nz-option>
                                  <nz-option nzValue="EUR" nzLabel="€ EUR - Euro"></nz-option>
                                  <nz-option nzValue="GBP" nzLabel="£ GBP - İngiliz Sterlini"></nz-option>
                                  <nz-option nzValue="JPY" nzLabel="¥ JPY - Japon Yeni"></nz-option>
                                  <nz-option nzValue="CHF" nzLabel="CHF - İsviçre Frangı"></nz-option>
                                </nz-select>
                              </div>
                            }

                            <!-- Liste -->
                            @if (itm.turu === 'Liste') {
                              <div class="ayar-satir-flags">
                                <label nz-checkbox [(ngModel)]="itm.ayarlar.coklu"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()">Çoklu Seçim</label>
                                <label nz-checkbox [(ngModel)]="itm.ayarlar.siralama"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()">Sıralanabilir</label>
                              </div>
                            }

                            <!-- Tablo -->
                            @if (itm.turu === 'Tablo') {
                              <div class="ayar-alan">
                                <div class="ayar-etiket-satir">
                                  <span class="ayar-etiket">Kolon İsimleri</span>
                                </div>
                                <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.kolonlarStr"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="Kolon1, Kolon2, Kolon3 (virgülle ayırın)"
                                       (ngModelChange)="tabloKolonlarGuncelle(itm, $event)" />
                              </div>
                              <div class="ayar-satir-flags">
                                <label nz-checkbox [(ngModel)]="itm.ayarlar.satirEkleme"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()">Satır Ekleme</label>
                                <label nz-checkbox [(ngModel)]="itm.ayarlar.satirSilme"
                                       [ngModelOptions]="{standalone: true}"
                                       (ngModelChange)="inlineAyarDegisti()">Satır Silme</label>
                              </div>
                            }

                            <!-- KareKod -->
                            @if (itm.turu === 'KareKod') {
                              <div class="ayar-alan">
                                <span class="ayar-etiket">QR Kod Boyutu</span>
                                <nz-select nzSize="small" [(ngModel)]="itm.ayarlar.boyut"
                                           [ngModelOptions]="{standalone: true}"
                                           nzPlaceHolder="Boyut"
                                           (ngModelChange)="inlineAyarDegisti()">
                                  <nz-option nzValue="small" nzLabel="Küçük (128px)"></nz-option>
                                  <nz-option nzValue="medium" nzLabel="Orta (256px)"></nz-option>
                                  <nz-option nzValue="large" nzLabel="Büyük (512px)"></nz-option>
                                </nz-select>
                              </div>
                            }

                            <!-- BarKod -->
                            @if (itm.turu === 'BarKod') {
                              <div class="ayar-alan">
                                <span class="ayar-etiket">Barkod Formatı</span>
                                <nz-select nzSize="small" [(ngModel)]="itm.ayarlar.barkodFormat"
                                           [ngModelOptions]="{standalone: true}"
                                           nzPlaceHolder="Format"
                                           (ngModelChange)="inlineAyarDegisti()">
                                  <nz-option nzValue="CODE128" nzLabel="CODE128"></nz-option>
                                  <nz-option nzValue="EAN13" nzLabel="EAN-13"></nz-option>
                                  <nz-option nzValue="EAN8" nzLabel="EAN-8"></nz-option>
                                  <nz-option nzValue="UPC" nzLabel="UPC"></nz-option>
                                  <nz-option nzValue="CODE39" nzLabel="CODE39"></nz-option>
                                  <nz-option nzValue="ITF14" nzLabel="ITF-14"></nz-option>
                                </nz-select>
                              </div>
                            }

                            <!-- Kod -->
                            @if (itm.turu === 'Kod') {
                              <div class="ayar-grid-2">
                                <div class="ayar-alan">
                                  <span class="ayar-etiket">Programlama Dili</span>
                                  <nz-select nzSize="small" [(ngModel)]="itm.ayarlar.dil"
                                             [ngModelOptions]="{standalone: true}"
                                             nzPlaceHolder="Dil"
                                             nzShowSearch
                                             (ngModelChange)="inlineAyarDegisti()">
                                    <nz-option nzValue="typescript" nzLabel="TypeScript"></nz-option>
                                    <nz-option nzValue="javascript" nzLabel="JavaScript"></nz-option>
                                    <nz-option nzValue="python" nzLabel="Python"></nz-option>
                                    <nz-option nzValue="go" nzLabel="Go"></nz-option>
                                    <nz-option nzValue="rust" nzLabel="Rust"></nz-option>
                                    <nz-option nzValue="html" nzLabel="HTML"></nz-option>
                                    <nz-option nzValue="css" nzLabel="CSS"></nz-option>
                                    <nz-option nzValue="sql" nzLabel="SQL"></nz-option>
                                    <nz-option nzValue="json" nzLabel="JSON"></nz-option>
                                    <nz-option nzValue="yaml" nzLabel="YAML"></nz-option>
                                  </nz-select>
                                </div>
                                <div class="ayar-alan">
                                  <span class="ayar-etiket">Satır Sayısı</span>
                                  <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.satirSayisi"
                                         [ngModelOptions]="{standalone: true}"
                                         placeholder="8"
                                         (ngModelChange)="inlineAyarDegisti()" />
                                </div>
                              </div>
                            }

                            <!-- Bilgi: türe özel ayar yok -->
                            @if (['Yazı', 'Parola', 'Sayı', 'Tarih', 'Tarih Saat', 'Saat', 'Ay', 'Hafta', 'Onay', 'Anahtar', 'Grup', 'Doğruluk', 'Simgeli Başlık', 'Matematik', 'RichText', 'İmza', 'Çizim', 'Aranjman'].includes(itm.turu)) {
                              <div class="ayar-bilgi">
                                <nz-tag nzColor="blue">{{ itm.turu }}</nz-tag>
                                <span class="ayar-bilgi-metin">Bu tür için özel ayar bulunmuyor. Genel ve Kısıtlama sekmelerini kullanın.</span>
                              </div>
                            }

                          </div>
                        </nz-tab>

                        <!-- OLAYLAR -->
                        <nz-tab nzTitle="Olaylar">
                          <div class="ayar-grup">
                            <div class="olay-bilgi-bar">
                              <nz-tag nzColor="geekblue">TypeScript</nz-tag>
                              <span class="ayar-bilgi-metin">Parametreler: form, prm, itm, deger</span>
                            </div>

                            <div class="ayar-alan">
                              <div class="ayar-etiket-satir">
                                <span class="ayar-etiket">Değişti</span>
                                @if (itm.ayarlar.olaylar.degisti) {
                                  <button nz-button nzSize="small" nzType="link"
                                          (click)="kodTest(itm, 'degisti')">
                                    <nz-icon nzType="play-circle" /> Test
                                  </button>
                                }
                              </div>
                              <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.olaylar.degisti"
                                        [ngModelOptions]="{standalone: true}"
                                        rows="3"
                                        class="kod-alani"
                                        placeholder="// Değer değiştiğinde çalışır&#10;// form: tüm parametreler, prm: proxy, itm: bu parametre, deger: yeni değer"
                                        (ngModelChange)="inlineAyarDegisti()"></textarea>
                            </div>
                            <div class="ayar-alan">
                              <div class="ayar-etiket-satir">
                                <span class="ayar-etiket">Seçildi</span>
                                @if (itm.ayarlar.olaylar.secildi) {
                                  <button nz-button nzSize="small" nzType="link"
                                          (click)="kodTest(itm, 'secildi')">
                                    <nz-icon nzType="play-circle" /> Test
                                  </button>
                                }
                              </div>
                              <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.olaylar.secildi"
                                        [ngModelOptions]="{standalone: true}"
                                        rows="3"
                                        class="kod-alani"
                                        placeholder="// Açılır kutu seçim olayında çalışır"
                                        (ngModelChange)="inlineAyarDegisti()"></textarea>
                            </div>
                            <div class="ayar-grid-2">
                              <div class="ayar-alan">
                                <div class="ayar-etiket-satir">
                                  <span class="ayar-etiket">Focus</span>
                                  @if (itm.ayarlar.olaylar.focus) {
                                    <button nz-button nzSize="small" nzType="link"
                                            (click)="kodTest(itm, 'focus')">
                                      <nz-icon nzType="play-circle" />
                                    </button>
                                  }
                                </div>
                                <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.olaylar.focus"
                                          [ngModelOptions]="{standalone: true}"
                                          rows="2"
                                          class="kod-alani"
                                          placeholder="// focus olayında çalışır"
                                          (ngModelChange)="inlineAyarDegisti()"></textarea>
                              </div>
                              <div class="ayar-alan">
                                <div class="ayar-etiket-satir">
                                  <span class="ayar-etiket">Blur</span>
                                  @if (itm.ayarlar.olaylar.blur) {
                                    <button nz-button nzSize="small" nzType="link"
                                            (click)="kodTest(itm, 'blur')">
                                      <nz-icon nzType="play-circle" />
                                    </button>
                                  }
                                </div>
                                <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.olaylar.blur"
                                          [ngModelOptions]="{standalone: true}"
                                          rows="2"
                                          class="kod-alani"
                                          placeholder="// blur olayında çalışır"
                                          (ngModelChange)="inlineAyarDegisti()"></textarea>
                              </div>
                            </div>
                            <div class="ayar-grid-2">
                              <div class="ayar-alan">
                                <div class="ayar-etiket-satir">
                                  <span class="ayar-etiket">Tıklanma</span>
                                  @if (itm.ayarlar.olaylar.tiklanma) {
                                    <button nz-button nzSize="small" nzType="link"
                                            (click)="kodTest(itm, 'tiklanma')">
                                      <nz-icon nzType="play-circle" />
                                    </button>
                                  }
                                </div>
                                <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.olaylar.tiklanma"
                                          [ngModelOptions]="{standalone: true}"
                                          rows="2"
                                          class="kod-alani"
                                          placeholder="// click olayında çalışır"
                                          (ngModelChange)="inlineAyarDegisti()"></textarea>
                              </div>
                              <div class="ayar-alan">
                                <div class="ayar-etiket-satir">
                                  <span class="ayar-etiket">Seçim Silindi</span>
                                  @if (itm.ayarlar.olaylar.secimSilindi) {
                                    <button nz-button nzSize="small" nzType="link"
                                            (click)="kodTest(itm, 'secimSilindi')">
                                      <nz-icon nzType="play-circle" />
                                    </button>
                                  }
                                </div>
                                <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.olaylar.secimSilindi"
                                          [ngModelOptions]="{standalone: true}"
                                          rows="2"
                                          class="kod-alani"
                                          placeholder="// seçim silindiğinde çalışır"
                                          (ngModelChange)="inlineAyarDegisti()"></textarea>
                              </div>
                            </div>

                            <!-- Formül / Hesaplanan Alan -->
                            <div class="ayar-alan formul-ayirici" style="margin-top: 8px; padding-top: 8px;">
                              <div class="ayar-etiket-satir">
                                <span class="ayar-etiket">Formül (Hesaplanan Değer)</span>
                                @if (itm.ayarlar?.formul) {
                                  <button nz-button nzSize="small" nzType="link"
                                          (click)="formulDegerlendir(itm)">
                                    <nz-icon nzType="thunderbolt" /> Hesapla
                                  </button>
                                }
                              </div>
                              <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.formul"
                                        [ngModelOptions]="{standalone: true}"
                                        rows="2"
                                        class="kod-alani"
                                        placeholder="// return prm.fiyat * prm.adet; // Diğer parametrelere erişim: form, prm"
                                        (ngModelChange)="inlineAyarDegisti()"></textarea>
                            </div>
                          </div>
                        </nz-tab>

                        <!-- KONTROLLER (VALIDASYONLAR) -->
                        <nz-tab nzTitle="Kontroller">
                          <div class="ayar-grup">
                            <div class="ayar-etiket-satir">
                              <span class="ayar-etiket">Doğrulama Kuralları</span>
                              <button nz-button nzSize="small" nzType="dashed"
                                      (click)="inlineKontrolEkle(itm)">+ Kural Ekle</button>
                            </div>
                            @for (key of kontrolAnahtarlari(itm); track key) {
                              <div class="kontrol-satir">
                                <div class="ayar-alan" style="flex: 2;">
                                  <span class="ayar-etiket">Fonksiyon (TypeScript)</span>
                                  <textarea nz-input nzSize="small" [(ngModel)]="itm.kontroller[key].fn"
                                            [ngModelOptions]="{standalone: true}"
                                            rows="3"
                                            class="kod-alani"
                                            placeholder="// Parametreler: form (tüm liste), itm (bu parametre)&#10;// return false; → doğrulama başarısız&#10;// if (!itm.degeri) return false;"
                                            (ngModelChange)="inlineAyarDegisti()"></textarea>
                                </div>
                                <div class="ayar-alan" style="flex: 1;">
                                  <span class="ayar-etiket">Hata Mesajı</span>
                                  <input nz-input nzSize="small" [(ngModel)]="itm.kontroller[key].mesaj"
                                         [ngModelOptions]="{standalone: true}"
                                         placeholder="Hata mesajı"
                                         (ngModelChange)="inlineAyarDegisti()" />
                                </div>
                                <div class="kontrol-aksiyonlar">
                                  <nz-select nzSize="small" [(ngModel)]="itm.kontroller[key].renk"
                                             [ngModelOptions]="{standalone: true}"
                                             style="width: 80px;"
                                             (ngModelChange)="inlineAyarDegisti()">
                                    <nz-option nzValue="red" nzLabel="Kırmızı"></nz-option>
                                    <nz-option nzValue="orange" nzLabel="Turuncu"></nz-option>
                                    <nz-option nzValue="yellow" nzLabel="Sarı"></nz-option>
                                  </nz-select>
                                  <button nz-button nzSize="small" nzType="link"
                                          (click)="kontrolTest(itm, key)"
                                          nz-tooltip nzTooltipTitle="Kuralı test et">
                                    <nz-icon nzType="play-circle" />
                                  </button>
                                  <button nz-button nzSize="small" nzType="text" nzDanger
                                          (click)="inlineKontrolSil(itm, key)">
                                    <nz-icon nzType="delete" />
                                  </button>
                                </div>
                              </div>
                            }
                            @if (kontrolAnahtarlari(itm).length === 0) {
                              <div class="ayar-bilgi">
                                <span class="ayar-bilgi-metin">Henüz doğrulama kuralı eklenmemiş. "Kural Ekle" ile yeni kural oluşturun.</span>
                              </div>
                            }
                          </div>
                        </nz-tab>

                        <!-- BAĞIMLILIKLAR -->
                        <nz-tab nzTitle="Bağımlılık">
                          <div class="ayar-grup">
                            <div class="ayar-etiket-satir">
                              <span class="ayar-etiket">Parametre Bağımlılıkları</span>
                              <button nz-button nzSize="small" nzType="dashed"
                                      (click)="bagimlilikEkle(itm)">+ Bağımlılık Ekle</button>
                            </div>
                            <div class="ayar-bilgi" style="margin-bottom: 6px;">
                              <nz-tag nzColor="purple">Koşullu Görünürlük</nz-tag>
                              <span class="ayar-bilgi-metin">Başka parametrelerin değerine göre bu parametrenin davranışını belirleyin.</span>
                            </div>
                            @for (bag of itm.ayarlar?.bagimliliklar ?? []; track $index) {
                              <div class="kontrol-satir">
                                <div class="ayar-alan" style="flex: 1;">
                                  <span class="ayar-etiket">Hedef Parametre</span>
                                  <nz-select nzSize="small" [(ngModel)]="bag.hedefParametre"
                                             [ngModelOptions]="{standalone: true}"
                                             nzShowSearch nzPlaceHolder="Parametre seçin"
                                             (ngModelChange)="inlineAyarDegisti()">
                                    @for (p of getParametreIsimleri(); track p.ismi) {
                                      <nz-option [nzValue]="p.ismi" [nzLabel]="p.baslik"></nz-option>
                                    }
                                  </nz-select>
                                </div>
                                <div class="ayar-alan" style="flex: 0.7;">
                                  <span class="ayar-etiket">Koşul</span>
                                  <nz-select nzSize="small" [(ngModel)]="bag.kosul"
                                             [ngModelOptions]="{standalone: true}"
                                             (ngModelChange)="inlineAyarDegisti()">
                                    <nz-option nzValue="esittir" nzLabel="Eşittir"></nz-option>
                                    <nz-option nzValue="esitDegil" nzLabel="Eşit Değil"></nz-option>
                                    <nz-option nzValue="iceriyor" nzLabel="İçeriyor"></nz-option>
                                    <nz-option nzValue="bos" nzLabel="Boş"></nz-option>
                                    <nz-option nzValue="bosDegil" nzLabel="Boş Değil"></nz-option>
                                    <nz-option nzValue="buyuk" nzLabel="Büyük"></nz-option>
                                    <nz-option nzValue="kucuk" nzLabel="Küçük"></nz-option>
                                  </nz-select>
                                </div>
                                <div class="ayar-alan" style="flex: 0.7;">
                                  <span class="ayar-etiket">Değer</span>
                                  <input nz-input nzSize="small" [(ngModel)]="bag.deger"
                                         [ngModelOptions]="{standalone: true}"
                                         placeholder="Karşılaştırma değeri"
                                         (ngModelChange)="inlineAyarDegisti()" />
                                </div>
                                <div class="ayar-alan" style="flex: 0.6;">
                                  <span class="ayar-etiket">Aksiyon</span>
                                  <nz-select nzSize="small" [(ngModel)]="bag.aksiyon"
                                             [ngModelOptions]="{standalone: true}"
                                             (ngModelChange)="inlineAyarDegisti()">
                                    <nz-option nzValue="gorunur" nzLabel="Görünür Yap"></nz-option>
                                    <nz-option nzValue="gizle" nzLabel="Gizle"></nz-option>
                                    <nz-option nzValue="zorunlu" nzLabel="Zorunlu Yap"></nz-option>
                                    <nz-option nzValue="sadeceOkunur" nzLabel="Salt Okunur"></nz-option>
                                    <nz-option nzValue="aktif" nzLabel="Aktif Yap"></nz-option>
                                    <nz-option nzValue="deaktif" nzLabel="Deaktif Yap"></nz-option>
                                  </nz-select>
                                </div>
                                <div class="kontrol-aksiyonlar">
                                  <button nz-button nzSize="small" nzType="text" nzDanger
                                          (click)="bagimlilikSil(itm, $index)">
                                    <nz-icon nzType="delete" />
                                  </button>
                                </div>
                              </div>
                            }
                            @if (!itm.ayarlar?.bagimliliklar?.length) {
                              <div class="ayar-bilgi">
                                <span class="ayar-bilgi-metin">Henüz bağımlılık tanımlanmamış. "Bağımlılık Ekle" ile koşullu kurallar oluşturun.</span>
                              </div>
                            }
                          </div>
                        </nz-tab>

                        <!-- JSON RAW EDITOR -->
                        <nz-tab nzTitle="JSON">
                          <div class="ayar-grup">
                            <div class="ayar-bilgi" style="margin-bottom: 6px;">
                              <nz-tag nzColor="volcano">Ham Veri</nz-tag>
                              <span class="ayar-bilgi-metin">Parametrenin ham JSON verisini görüntüleyin ve düzenleyin.</span>
                            </div>
                            <div class="ayar-alan">
                              <textarea nz-input nzSize="small"
                                        [ngModel]="getParametreJson(itm)"
                                        [ngModelOptions]="{standalone: true}"
                                        rows="12"
                                        class="kod-alani json-editor"
                                        placeholder="{}"
                                        (ngModelChange)="jsonDanGuncelle(itm, $event, i)"></textarea>
                            </div>
                            <div class="gelismis-alt-bar" style="background: transparent; padding: 6px 0; border: none;">
                              <button nz-button nzSize="small" nzType="dashed"
                                      (click)="parametreyiPanoyaKopyala(itm)">
                                <nz-icon nzType="copy" /> Panoya Kopyala
                              </button>
                              <button nz-button nzSize="small" nzType="dashed"
                                      (click)="parametreDisaAktarTekil(itm)">
                                <nz-icon nzType="download" /> JSON İndir
                              </button>
                            </div>
                          </div>
                        </nz-tab>

                      </nz-tabs>

                      <!-- Alt Aksiyonlar -->
                      <div class="gelismis-alt-bar">
                        <button nz-button nzSize="small" nzType="dashed"
                                (click)="parametreyiPanoyaKopyala(itm)"
                                nz-tooltip nzTooltipTitle="JSON olarak panoya kopyala">
                          <nz-icon nzType="copy" /> JSON Kopyala
                        </button>
                        <button nz-button nzSize="small" nzType="dashed"
                                (click)="parametreDisaAktarTekil(itm)"
                                nz-tooltip nzTooltipTitle="Bu parametreyi JSON dosyası olarak indir">
                          <nz-icon nzType="download" /> Dışa Aktar
                        </button>
                        <button nz-button nzSize="small" nzType="default"
                                (click)="toggleInlineAyarlar(i)">
                          <nz-icon nzType="close" /> Kapat
                        </button>
                      </div>
                    </div>
                    }

                    <!-- JSON Görünüm (toggle ile açılır) -->
                    @if (jsonGorunumAcikMi(i)) {
                    <div class="json-gorunum-panel">
                      <div class="json-gorunum-baslik">
                        <nz-tag nzColor="volcano">JSON</nz-tag>
                        <span class="ayar-bilgi-metin">{{ itm.ismi }} - Ham Veri</span>
                        <button nz-button nzSize="small" nzType="text"
                                (click)="jsonGorunumToggle(i)">
                          <nz-icon nzType="close" />
                        </button>
                      </div>
                      <pre class="json-icerik">{{ getParametreJson(itm) }}</pre>
                    </div>
                    }

                    @switch (itm?.turu) {

                    @case ("Yazı") {

                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '✏️'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <input  [placeholder]="itm.yerTutucu ?? itm.baslik ?? ''" nz-input type="text" [name]="itm.ismi" [(ngModel)]="itm.degeri"
                        [disabled]="itm?.ayarlar?.sadeceOkunur ?? false"
                        [minLength]="itm?.ayarlar?.min ?? 999999999" [maxLength]="itm?.ayarlar?.maks ?? 999999999"
                        (ngModelChange)="itm?.ayarlar?.olaylar?.degisti ? olayDegisti(itm, $event, parametreler):undefined;"
                        (focus)="itm?.ayarlar?.olaylar?.focus ? olayFocus(itm, $event, parametreler):undefined;"
                        (blur)="kontrolDeger(itm,parametreler);itm?.ayarlar?.olaylar?.blur ? olayBlur(itm, $event, parametreler):undefined;"
                        (click)="itm?.ayarlar?.olaylar?.tiklanma ? olayTiklanma(itm, $event, parametreler):undefined;"
                        [ngModelOptions]="{standalone: true}"/>
                    </nz-input-wrapper>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata"
                          (click)="itm.hatalar.splice($index,1);">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Yazı Alanı") {

                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '✏️'"
                                    class="flex-1 w-full prefix-ustte"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <textarea [placeholder]="itm.yerTutucu ?? itm.baslik ?? ''"
                                  class="p-0"
                                  nz-input
                                  type="text"
                                  [name]="itm.ismi"
                                  [(ngModel)]="itm.degeri"
                                  [disabled]="itm?.ayarlar?.sadeceOkunur ?? false"
                                  [minLength]="itm?.ayarlar?.min ?? 999999999"
                                  [maxLength]="itm?.ayarlar?.maks ?? 999999999"
                                  (blur)="kontrolDeger(itm,parametreler)"
                                  [rows]="itm?.ayarlar?.satirSayisi ?? 3"
                                  [ngModelOptions]="{standalone: true}"></textarea>
                    </nz-input-wrapper>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }

                    }

                    @case ("Parola") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '🔒'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <input  [placeholder]="itm.yerTutucu ?? itm.baslik ?? ''" nz-input type="password" [name]="itm.ismi" [(ngModel)]="itm.degeri"
                            [minLength]="itm?.ayarlar?.min ?? 999999999" [maxLength]="itm?.ayarlar?.maks ?? 999999999"
                            (blur)="kontrolDeger(itm,parametreler)"  [ngModelOptions]="{standalone: true}"/>
                    </nz-input-wrapper>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Sayı") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '🔢'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <input  [placeholder]="itm.yerTutucu ?? itm.baslik ?? ''" nz-input type="number" [name]="itm.ismi" [(ngModel)]="itm.degeri"
                                [min]="itm?.ayarlar?.min" [max]="itm?.ayarlar?.maks"
                                (blur)="kontrolDeger(itm,parametreler)" [ngModelOptions]="{standalone: true}"/>
                    </nz-input-wrapper>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Tarih") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '📅'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <!-- <nz-date-picker nz-input [name]="itm.ismi" [(ngModel)]="itm.degeri"
                        (ngModelChange)="CD.detectChanges();"></nz-date-picker> -->
                        <input  nz-input type="date"  [name]="itm.ismi" step="1" [(ngModel)]="itm.degeri" [max]="itm?.ayarlar?.max"
                            [min]="itm?.ayarlar?.min"
                            (ngModelChange)="CD.detectChanges();"
                            (blur)="kontrolDeger(itm,parametreler)" [ngModelOptions]="{standalone: true}" />
                    </nz-input-wrapper>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Saat") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '🕓'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <input  nz-input type="time"  [name]="itm.ismi" step="1" [(ngModel)]="itm.degeri" [max]="itm?.ayarlar?.max"
                                [min]="itm?.ayarlar?.min"
                                (ngModelChange)="CD.detectChanges();"
                                (blur)="kontrolDeger(itm,parametreler)" [ngModelOptions]="{standalone: true}"/>
                    </nz-input-wrapper>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Tarih Saat") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '📅🕓'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">

                        <div class="flex-1">
                            <div nz-typography
                                 class="mb-0 w-full"
                                 (click)="inputRef.showPicker ? inputRef.showPicker() : inputRef.click();"
                                 nzType="danger">
                                <div nz-typography
                                     class="mb-0 w-full"
                                     [nzType]="'secondary'">
                                    {{ itm.degeri ? (itm.degeri | date:itm?.ayarlar?.format ?? 'dd.MM.yyyy HH:mm') :
                                    itm.yerTutucu ?? itm.baslik ?? '' }}
                                </div>
                                <input #inputRef  nz-input type="datetime-local"  [name]="itm.ismi" step="1" [(ngModel)]="itm.degeri" [max]="itm?.ayarlar?.max"
                            [min]="itm?.ayarlar?.min"
                            (ngModelChange)="CD.detectChanges();"
                            (blur)="kontrolDeger(itm,parametreler)" [ngModelOptions]="{standalone: true}" style="opacity: 0;pointer-events:none;position: absolute;top: 0;left: 0;width: 100%;height: 100%;"/>
                            </div>

                            @if (itm?.degeri) {
                            <span nz-input-group-slot="suffix"
                                  type="suffix"
                                  style="position: absolute;right: 0;top: 0;bottom: 0;"
                                  class="ant-input-prefix ng-star-inserted">
                                <button nz-button
                                        nzType="text"
                                        nzShape="circle"
                                        nzSize="small"
                                        (click)="itm.degeri=null;CD.detectChanges();">
                                    <i nz-icon
                                       nzType="close-circle"
                                       nzTheme="twotone"
                                       nzTwotoneColor="#ff0000"></i>
                                </button>

                            </span>
                            }


                        </div>
                    </nz-input-wrapper>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Ay") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '🌕'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <input  nz-input type="month"  [name]="itm.ismi" step="1" [(ngModel)]="itm.degeri" [max]="itm?.ayarlar?.max"
                                        [min]="itm?.ayarlar?.min"
                                        (ngModelChange)="CD.detectChanges();"
                                        (blur)="kontrolDeger(itm,parametreler)" [ngModelOptions]="{standalone: true}" />
                    </nz-input-wrapper>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Hafta") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '📆'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <input  nz-input type="week"  [name]="itm.ismi" step="1" [(ngModel)]="itm.degeri" [max]="itm?.ayarlar?.max"
                                            [min]="itm?.ayarlar?.min"
                                            (ngModelChange)="CD.detectChanges();"
                                            (blur)="kontrolDeger(itm,parametreler)" [ngModelOptions]="{standalone: true}"/>
                    </nz-input-wrapper>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Onay") {
                    <!-- <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label> -->
                    <span>{{itm?.ayarlar?.solSimge ?? '👍'}}</span>
                    <div class="ui checkbox">
                        <input type="checkbox" [name]="itm.ismi" [(ngModel)]="itm.degeri" [ngModelOptions]="{standalone: true}">
                        <label (click)="itm.degeri=!itm.degeri;">{{ itm?.baslik ?? "" }}</label>
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Anahtar") {
                    <!-- <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label> -->
                    <span>{{itm?.ayarlar?.solSimge ?? '🎚️'}}</span>
                    <div class="ui slider checkbox">
                        <input type="checkbox" [name]="itm.ismi" [(ngModel)]="itm.degeri" [ngModelOptions]="{standalone: true}">
                        <label>{{ itm?.baslik ?? "" }}</label>
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Resim") {
                    <div>
                        <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                        <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '📸'"
                                        class="flex-1 w-full align-items-center"
                                        [title]="itm.ipucu ?? ''"
                                        [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                            @if(itm.degeri?.objectUrl){
                            <img class="mr-2"
                                 style="height: 2rem;width:2rem;object-fit: cover;border-radius: 3px;"
                                 [src]="itm.degeri?.objectUrl"
                                 (click)="tiklandiResimAc(itm);$event.stopPropagation();">
                            <span nz-typography
                                  (click)="tiklandiResimSecDegistir(itm);"
                                  nzType="success"
                                  class="flex-1 w-full">{{ itm?.degeri?.dosya?.name}}</span>
                            <button nz-button
                                    nzType="text"
                                    nzShape="circle"
                                    (click)="tiklandiResimSil(itm);$event.stopPropagation();">❌</button>
                            } @else {
                            <span nz-typography
                                  (click)="tiklandiResimSecDegistir(itm);"
                                  class="w-full"
                                  nzType="danger"><span nz-typography
                                      [nzType]="'secondary'">
                                    {{ itm.yerTutucu?? itm.baslik ?? ''}} </span> Dosya Seçilmemiş
                            </span>
                            }

                        </nz-input-wrapper>
                        <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                        @for (uyr of itm.uyarilar; track $index) {
                        <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                              (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                        }
                        @for (hata of itm.hatalar; track $index) {
                        <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                        }
                    </div>
                    }
                    @case ("Video") {
                    <div (click)="tiklandiVideoSecDegistir(itm);">
                        <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                        <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '🎥'"
                                        class="flex-1 w-full align-items-center"
                                        [title]="itm.ipucu ?? ''"
                                        [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                            @if(itm.degeri?.objectUrl){
                            <video class="mr-2"
                                   [src]="itm.degeri?.objectUrl"
                                   muted
                                   (click)="tiklandiResimAc(itm);$event.stopPropagation();"
                                   style="height: 2rem;width:2rem;object-fit: cover;border-radius: 3px;"></video>
                            <!-- <img class="mr-2" style="max-height: 2rem;width:2rem;object-fit: contain;"
                            [src]="itm.degeri?.objectUrl"> -->
                            <span nz-typography
                                  nzType="success"
                                  class="flex-1">{{ itm?.degeri?.dosya?.name}}</span>
                            <button nz-button
                                    nzType="text"
                                    nzShape="circle"
                                    (click)="tiklandiResimSil(itm);$event.stopPropagation();">❌</button>
                            } @else {
                            <span nz-typography
                                  nzType="danger"><span nz-typography
                                      [nzType]="'secondary'">
                                    {{ itm.yerTutucu?? itm.baslik ?? ''}} </span> Dosya Seçilmemiş
                            </span>
                            }

                        </nz-input-wrapper>
                        <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                        @for (uyr of itm.uyarilar; track $index) {
                        <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                              (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                        }
                        @for (hata of itm.hatalar; track $index) {
                        <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                        }
                    </div>
                    }

                    @case ("Dosya") {
                    <div (click)="tiklandiDosyaSecDegistir(itm);">
                        <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                        <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '📸'"
                                        class="flex-1 w-full align-items-center"
                                        [title]="itm.ipucu ?? ''"
                                        [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                            @if(itm.degeri?.objectUrl){
                            <img class="mr-2"
                                 style="height: 2rem;width:2rem;object-fit: cover;border-radius: 3px;"
                                 src="/simgeler/dosya-dolap.png">
                            <span nz-typography
                                  nzType="success"
                                  class="flex-1">{{ itm?.degeri?.dosya?.name}}</span>
                            <button nz-button
                                    nzType="text"
                                    nzShape="circle"
                                    (click)="tiklandiResimSil(itm);$event.stopPropagation();">❌</button>
                            } @else {
                            <span nz-typography
                                  nzType="danger"><span nz-typography
                                      [nzType]="'secondary'">
                                    {{ itm.yerTutucu?? itm.baslik ?? ''}} </span> Dosya Seçilmemiş
                            </span>
                            }

                        </nz-input-wrapper>
                        <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                        @for (uyr of itm.uyarilar; track $index) {
                        <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                              (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                        }
                        @for (hata of itm.hatalar; track $index) {
                        <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                        }
                    </div>
                    }

                    @case ("Ses") {
                    <div>
                        <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                        <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '🔊'"
                                        class="flex-1 w-full align-items-center"
                                        [title]="itm.ipucu ?? ''"
                                        [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                            @if(itm.degeri?.objectUrl){
                            <div class="flex-1 flex-column w-full align-items-center">
                                <audio class="mr-2 flex-1"
                                       [src]="itm.degeri?.objectUrl"
                                       controls
                                       style="height: 24px"></audio>
                                <!-- <div nz-typography nzType="success" class="flex-1">{{ itm?.degeri?.dosya?.name}}</div> -->
                            </div>

                            <button nz-button
                                    nzType="text"
                                    nzShape="circle"
                                    (click)="tiklandiResimSil(itm);$event.stopPropagation();">❌</button>

                            } @else {
                            <span nz-typography
                                  nzType="danger"
                                  (click)="tiklandiSesSecDegistir(itm);">Dosya
                                Seçilmemiş</span>
                            }

                        </nz-input-wrapper>
                        <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                        @for (uyr of itm.uyarilar; track $index) {
                        <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                              (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                        }
                        @for (hata of itm.hatalar; track $index) {
                        <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                        }
                    </div>
                    }

                    @case ("2liSatır") {
                    <div class="grid"
                         style="gap: 4px;">
                        <div class="col">
                            <ng-container
                                          *ngTemplateOutlet="recursiveParametre; context:{ $implicit: [itm.degeri?.solTaraf] }" />
                        </div>
                        <div class="col">
                            <ng-container
                                          *ngTemplateOutlet="recursiveParametre; context:{ $implicit: [itm.degeri?.sagTaraf] }" />
                        </div>
                    </div>
                    }

                    @case ("3lüSatır") {
                    <div class="grid"
                         style="gap: 4px;">
                        <div class="col">
                            <ng-container
                                          *ngTemplateOutlet="recursiveParametre; context:{ $implicit: [itm.degeri?.solTaraf] }" />
                        </div>
                        <div class="col">
                            <ng-container
                                          *ngTemplateOutlet="recursiveParametre; context:{ $implicit: [itm.degeri?.ortaTaraf] }" />
                        </div>
                        <div class="col">
                            <ng-container
                                          *ngTemplateOutlet="recursiveParametre; context:{ $implicit: [itm.degeri?.sagTaraf] }" />
                        </div>
                    </div>
                    }

                    @case ("Sekme") {
                    <div class="card-container">
                        <nz-tabs nzType="card"
                                   (click)="CD.detectChanges();"
                                   nzSize="small">
                            @for (tab of itm.degeri ?? []; track $index) {
                            <nz-tab [nzTitle]="tab.baslik">
                                <ng-container
                                              *ngTemplateOutlet="recursiveParametre; context:{ $implicit: tab.degeri ?? [] }" />
                            </nz-tab>
                            }

                        </nz-tabs>
                    </div>
                    }


                    @case ("Simgeli Başlık") {
                    <div class="card-container">
                        <h2 class="ui icon header w-full">
                            <i class="{{ itm?.degeri?.simge }} icon"
                               style="color: var(--py-metin-devre-disi);"></i>
                            <div class="content">
                                {{ itm?.degeri?.baslik ?? '' }}
                                <div class="sub header">
                                    {{ itm?.degeri?.altBaslik ?? '' }}
                                </div>
                            </div>
                        </h2>
                    </div>
                    }


                    @case("Açılır Kutu") {
                    <!-- (onInit)="itm?.ayarlar?.fapiAyarlar ? acilirKutuAra(itm, $event):undefined;" -->
                    <div (onInit)="itm?.ayarlar?.fapiAyarlar ? acilirKutuAra(itm, $event, parametreler):undefined;">
                        <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                        <div class="aku-select-satir">
                        <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '🔊'"
                                        class="flex-1 align-items-center"
                                        [title]="itm.ipucu ?? ''"
                                        [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">


                            <nz-select [nzPlaceHolder]="itm.yerTutucu ?? itm.baslik"
                                       [(ngModel)]="itm.degeri"
                                       [ngModelOptions]="{standalone: true}"
                                       [nzDisabled]="itm?.ayarlar?.sadeceOkunur ?? false"
                                       [nzShowSearch]="itm?.ayarlar?.arama ?? false"
                                       [nzAllowClear]="itm?.ayarlar?.silme ?? false"
                                       [nzLoading]="itm?.ayarlar?.fapiAyarlar ? itm?.mesgul :false"
                                       [disabled]="itm?.ayarlar?.sadeceOkunur ?? false"
                                       (nzOnSearch)="itm?.ayarlar?.fapiAyarlar ? acilirKutuAra(itm, $event, parametreler):undefined;"
                                       [nzServerSearch]="itm?.ayarlar?.fapiAyarlar ?? false"
                                       (nzFocus)="itm?.ayarlar?.fapiAyarlar ? acilirKutuAra(itm, '', parametreler):undefined;"
                                       (nzOnClear)="itm?.ayarlar?.olaylar?.secimSilindi ? olaySecimSilindi(itm, $event, parametreler):undefined;kontrolDeger(itm,parametreler);CD.detectChanges();"
                                       (ngModelChange)="itm?.ayarlar?.olaylar?.degisti ? olayDegisti(itm, $event, parametreler):undefined;kontrolDeger(itm,parametreler);CD.detectChanges();"
                                       (nzBlur)="kontrolDeger(itm,parametreler);CD.detectChanges();"
                                       [nzCustomTemplate]="itm?.ayarlar?.itemSablon?.aktif ? akuSeciliTpl : null"
                                       [nzDropdownRender]="itm?.ayarlar?.hizliEkle ? akuHizliEkleTpl : null"
                                       style="width:100%;margin:0;">
                                <ng-template #akuSeciliTpl let-s>
                                  @let sd = acilirKutuSeciliSecenek(itm);
                                  <span nz-popover [nzPopoverContent]="akuOnizlemeTpl" nzPopoverTrigger="hover" nzPopoverPlacement="bottomLeft" style="cursor:default;">
                                    @if (sd?.renk) {<span style="display:inline-block;width:8px;height:8px;border-radius:50%;vertical-align:middle;margin-right:4px;" [style.background]="sd.renk"></span>}
                                    <span>{{s.nzLabel}}</span>
                                    @if (sd?.aciklama) {<span style="color:#8c8c8c;font-size:10px;margin-left:4px;">· {{sd.aciklama}}</span>}
                                  </span>
                                  <ng-template #akuOnizlemeTpl>
                                    <div class="aku-onizleme" (mousedown)="$event.stopPropagation(); $event.preventDefault();">
                                      @if (itm.degeri && itm.ayarlar?.fapiAyarlar?.vt) {
                                        @let onizleme = acilirKutuOnizlemeVeri(itm);
                                        @if (onizleme) {
                                          @for (alan of onizleme; track alan.ismi) {
                                            <div class="aku-onizleme-satir">
                                              <span class="aku-onizleme-etiket">{{ alan.baslik }}</span>
                                              <span class="aku-onizleme-deger">{{ alan.degeri || '—' }}</span>
                                            </div>
                                          }
                                        } @else {
                                          <div style="color:#8c8c8c;font-size:11px;">Yükleniyor...</div>
                                        }
                                      }
                                    </div>
                                  </ng-template>
                                </ng-template>
                                <ng-template #akuHizliEkleTpl>
                                  <nz-divider style="margin:4px 0;"></nz-divider>
                                  <div class="aku-hizli-ekle" (mousedown)="$event.preventDefault()" (click)="acilirKutuHizliEkle(itm)">
                                    <nz-icon nzType="plus" /> Yeni {{ itm.ayarlar.hizliEkle }} Ekle
                                  </div>
                                </ng-template>

                                @if (!itm?.mesgul) {
                                @for (secenek of itm?.ayarlar?.secenekler ?? []; track $index) {
                                  @let mapped = acilirKutuItm(itm, secenek);
                                  @if (itm?.ayarlar?.itemSablon?.aktif) {
                                    <nz-option nzCustomContent
                                               [nzValue]="mapped?.value"
                                               [nzLabel]="acilirKutuSeciliLabel(itm, mapped)">
                                      <div class="aku-item">
                                        @if (itm.ayarlar.itemSablon.renkGoster && (secenek?.renk || mapped?.renk)) {
                                          <span class="aku-renk" [style.background]="secenek?.renk || mapped?.renk"></span>
                                        }
                                        @if (itm.ayarlar.itemSablon.simgeGoster && (secenek?.simge || mapped?.simge)) {
                                          <span class="aku-simge">{{ secenek?.simge || mapped?.simge }}</span>
                                        }
                                        @if (itm.ayarlar.itemSablon.resimGoster && (secenek?.resimUrl || mapped?.resimUrl)) {
                                          <img class="aku-resim" [src]="secenek?.resimUrl || mapped?.resimUrl" loading="lazy" />
                                        }
                                        <span class="aku-icerik">
                                          <span class="aku-etiket">{{ mapped?.label }}</span>
                                          @if (itm.ayarlar.itemSablon.aciklamaGoster && (secenek?.aciklama || mapped?.aciklama)) {
                                            <span class="aku-aciklama">{{ secenek?.aciklama || mapped?.aciklama }}</span>
                                          }
                                        </span>
                                        @if (itm.ayarlar.baglantiModu === 'modal' && itm.ayarlar.fapiAyarlar?.vt) {
                                          <span class="aku-goz-btn" (click)="$event.stopPropagation(); acilirKutuBaglantiAc(itm, mapped?.value)" nz-tooltip nzTooltipTitle="Görüntüle">
                                            <nz-icon nzType="eye" />
                                          </span>
                                        }
                                      </div>
                                    </nz-option>
                                  } @else {
                                    <nz-option nzCustomContent
                                               [nzValue]="mapped?.value"
                                               [nzLabel]="mapped?.label">
                                      <div class="aku-item aku-item-sade">
                                        <span class="aku-etiket">{{ mapped?.label }}</span>
                                        @if (itm.ayarlar?.baglantiModu === 'modal' && itm.ayarlar?.fapiAyarlar?.vt) {
                                          <span class="aku-goz-btn" (click)="$event.stopPropagation(); acilirKutuBaglantiAc(itm, mapped?.value)" nz-tooltip nzTooltipTitle="Görüntüle">
                                            <nz-icon nzType="eye" />
                                          </span>
                                        }
                                      </div>
                                    </nz-option>
                                  }
                                }
                                } @else {
                                <nz-option nzDisabled
                                           nzCustomContent>
                                    <nz-icon nzType="loading"
                                             class="loading-icon" />
                                    Veriler Alınıyor
                                </nz-option>
                                }

                            </nz-select>
                        </nz-input-wrapper>
                        @if (itm?.ayarlar?.baglantiModu && itm.degeri) {
                          <span class="aku-goz-suffix" (click)="acilirKutuBaglantiAc(itm)" nz-tooltip nzTooltipTitle="Görüntüle">
                            <nz-icon nzType="eye" />
                          </span>
                        }
                        </div>
                        @if (itm?.ayarlar?.baglantiSablonu && !itm?.ayarlar?.baglantiModu && itm.degeri) {
                          <a class="aku-baglanti-btn aku-baglanti-kompakt" (click)="acilirKutuBaglantiAc(itm)" nz-tooltip nzTooltipTitle="Aç">
                            <nz-icon nzType="link" /> Aç
                          </a>
                        }
                        <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                        @for (uyr of itm.uyarilar; track $index) {
                        <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                              (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                        }
                        @for (hata of itm.hatalar; track $index) {
                        <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                        }
                    </div>
                    }

                    @case ("Renk") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '🎨'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <input  [placeholder]="itm.yerTutucu ?? itm.baslik ?? ''" nz-input type="color" [name]="itm.ismi" [(ngModel)]="itm.degeri"
                            (ngModelChange)="itm?.ayarlar?.olaylar?.degisti ? olayDegisti(itm, $event, parametreler):undefined;"
                            (blur)="kontrolDeger(itm,parametreler);itm?.ayarlar?.olaylar?.blur ? olayBlur(itm, $event, parametreler):undefined;"
                            [ngModelOptions]="{standalone: true}"/>
                    </nz-input-wrapper>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Oylama") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="flex flex-column gap-2">
                        @for (secenek of itm?.ayarlar?.secenekler ?? []; track $index) {
                        <div class="flex align-items-center gap-2">
                            <nz-radio [nzValue]="secenek.deger" [(ngModel)]="itm.degeri" [ngModelOptions]="{standalone: true}">
                                {{ secenek.etiket }}
                            </nz-radio>
                            @if (itm?.ayarlar?.sonuclarGorunur && secenek.renk) {
                            <nz-tag [nzColor]="secenek.renk">{{ secenek.renk }}</nz-tag>
                            }
                        </div>
                        }
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("İlerleme Çubuğu") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="flex flex-column gap-2">
                        <nz-progress [nzPercent]="itm.degeri || 0"
                                    [nzStatus]="getProgressStatus(itm.degeri || 0, itm?.ayarlar?.max)"
                                    [nzStrokeColor]="itm?.ayarlar?.renk || getProgressGradient(itm.degeri || 0, itm?.ayarlar?.max)"
                                    [nzShowInfo]="itm?.ayarlar?.yuzdeGoster !== false">
                        </nz-progress>
                        @if (itm?.ayarlar?.yuzdeGoster !== false) {
                        <div class="text-center text-black-alpha-60">{{ itm.degeri || 0 }}%</div>
                        }
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Zaman Aralığı") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="grid" style="gap: 8px;">
                        <div class="col">
                            <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '📅'"
                                            class="w-full"
                                            [title]="'Başlangıç: ' + (itm.ipucu ?? '')">
                                <input nz-input type="date"
                                       [name]="itm.ismi + '_baslangic'"
                                       [value]="getZamanAraligiDegeri(itm, 'baslangic')"
                                       [min]="itm?.ayarlar?.baslangicMin"
                                       (input)="setZamanAraligiDegeri(itm, 'baslangic', $event.target.value);CD.detectChanges();"
                                       [ngModelOptions]="{standalone: true}" />
                            </nz-input-wrapper>
                        </div>
                        <div class="col">
                            <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '📅'"
                                            class="w-full"
                                            [title]="'Bitiş: ' + (itm.ipucu ?? '')">
                                <input nz-input type="date"
                                       [name]="itm.ismi + '_bitis'"
                                       [value]="getZamanAraligiDegeri(itm, 'bitis')"
                                       [max]="itm?.ayarlar?.bitisMax"
                                       (input)="setZamanAraligiDegeri(itm, 'bitis', $event.target.value);CD.detectChanges();"
                                       [ngModelOptions]="{standalone: true}" />
                            </nz-input-wrapper>
                        </div>
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Konum") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="flex flex-column gap-2">
                        @if (itm.degeri?.enlem && itm.degeri?.boylam) {
                        <div class="flex align-items-center gap-2">
                            <span class="text-black-alpha-60">Enlem: {{ itm.degeri.enlem.toFixed(6) }}, Boylam: {{ itm.degeri.boylam.toFixed(6) }}</span>
                            <button nz-button nzSize="small" nzType="link" (click)="konumAc(itm)">Haritada Aç</button>
                            <button nz-button nzSize="small" nzType="link" (click)="konumKopyala(itm)">Kopyala</button>
                        </div>
                        } @else {
                        <span class="text-black-alpha-60">Konum seçilmemiş</span>
                        }
                        <div class="flex gap-2">
                            <button nz-button
                                    nzType="primary"
                                    nzSize="small"
                                    (click)="konumAl(itm)"
                                    [disabled]="itm?.ayarlar?.sadeceOkunur">
                                <nz-icon nzType="environment" />
                                Konum Al
                            </button>
                            @if (itm?.ayarlar?.sadeceOkunur) {
                            <nz-tag nzColor="blue">Sadece Okunur</nz-tag>
                            }
                        </div>
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Doğruluk") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '✅'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <nz-select [(ngModel)]="itm.degeri"
                                   [ngModelOptions]="{standalone: true}"
                                   [nzPlaceHolder]="itm.yerTutucu ?? 'Seçin'"
                                   [nzDisabled]="itm?.ayarlar?.sadeceOkunur ?? false"
                                   nzAllowClear
                                   style="width: 100%;"
                                   (ngModelChange)="itm?.ayarlar?.olaylar?.degisti ? olayDegisti(itm, $event, parametreler):undefined;kontrolDeger(itm,parametreler);CD.detectChanges();">
                            <nz-option nzValue="Doğru" nzLabel="✅ Doğru"></nz-option>
                            <nz-option nzValue="Yanlış" nzLabel="❌ Yanlış"></nz-option>
                            <nz-option nzValue="Bilinmiyor" nzLabel="❓ Bilinmiyor"></nz-option>
                        </nz-select>
                    </nz-input-wrapper>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Para") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '💰'"
                                    [nzSuffix]="itm?.ayarlar?.paraBirimi ?? 'TRY'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <input nz-input type="number" [name]="itm.ismi" [(ngModel)]="itm.degeri"
                               [placeholder]="itm.yerTutucu ?? '0.00'"
                               [disabled]="itm?.ayarlar?.sadeceOkunur ?? false"
                               [min]="itm?.ayarlar?.min" [max]="itm?.ayarlar?.maks" [step]="itm?.ayarlar?.adim ?? 0.01"
                               (ngModelChange)="itm?.ayarlar?.olaylar?.degisti ? olayDegisti(itm, $event, parametreler):undefined;"
                               (blur)="kontrolDeger(itm,parametreler)"
                               [ngModelOptions]="{standalone: true}" />
                    </nz-input-wrapper>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Liste") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="flex flex-column gap-2">
                        <div class="flex flex-wrap gap-1">
                            @for (eleman of itm.degeri ?? []; track $index) {
                            <nz-tag nzMode="closeable"
                                    (nzOnClose)="listeElemanSil(itm, $index)">
                                {{ eleman }}
                            </nz-tag>
                            }
                        </div>
                        @if (!itm?.ayarlar?.sadeceOkunur) {
                        <div class="flex gap-2">
                            <input nz-input nzSize="small"
                                   [placeholder]="itm.yerTutucu ?? 'Yeni eleman ekle...'"
                                   #listeInput
                                   (keydown.enter)="listeElemanEkle(itm, listeInput.value); listeInput.value='';"
                                   style="flex: 1;" />
                            <button nz-button nzSize="small" nzType="primary"
                                    (click)="listeElemanEkle(itm, listeInput.value); listeInput.value='';">
                                <nz-icon nzType="plus" /> Ekle
                            </button>
                        </div>
                        }
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Tablo") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="flex flex-column gap-2">
                        <nz-table #tabloRef
                                  [nzData]="itm.degeri?.satirlar ?? []"
                                  nzSize="small"
                                  [nzShowPagination]="false"
                                  nzBordered
                                  [nzScroll]="{ x: '100%' }">
                            <thead>
                                <tr>
                                    <th nzWidth="40px">#</th>
                                    @for (kolon of itm.degeri?.kolonlar ?? itm?.ayarlar?.kolonlar ?? []; track $index) {
                                    <th>{{ kolon }}</th>
                                    }
                                    @if (!itm?.ayarlar?.sadeceOkunur) {
                                    <th nzWidth="60px">İşlem</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                @for (satir of itm.degeri?.satirlar ?? []; track $index) {
                                <tr>
                                    <td>{{ $index + 1 }}</td>
                                    @for (kolon of itm.degeri?.kolonlar ?? itm?.ayarlar?.kolonlar ?? []; track $index) {
                                    <td>
                                        <input nz-input nzSize="small" [(ngModel)]="satir[kolon]"
                                               [ngModelOptions]="{standalone: true}"
                                               [disabled]="itm?.ayarlar?.sadeceOkunur"
                                               (ngModelChange)="inlineAyarDegisti()" />
                                    </td>
                                    }
                                    @if (!itm?.ayarlar?.sadeceOkunur) {
                                    <td>
                                        <button nz-button nzSize="small" nzType="text" nzDanger
                                                (click)="tabloSatirSil(itm, $index)">
                                            <nz-icon nzType="delete" />
                                        </button>
                                    </td>
                                    }
                                </tr>
                                }
                            </tbody>
                        </nz-table>
                        @if (!itm?.ayarlar?.sadeceOkunur) {
                        <div class="flex gap-2">
                            <button nz-button nzSize="small" nzType="dashed"
                                    (click)="tabloSatirEkle(itm)">
                                <nz-icon nzType="plus" /> Satır Ekle
                            </button>
                            <button nz-button nzSize="small" nzType="dashed"
                                    (click)="tabloKolonEkle(itm)">
                                <nz-icon nzType="plus" /> Kolon Ekle
                            </button>
                        </div>
                        }
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("KareKod") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '📱'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <input nz-input [placeholder]="itm.yerTutucu ?? 'QR kod değeri'" [name]="itm.ismi" [(ngModel)]="itm.degeri"
                               [disabled]="itm?.ayarlar?.sadeceOkunur ?? false"
                               (ngModelChange)="itm?.ayarlar?.olaylar?.degisti ? olayDegisti(itm, $event, parametreler):undefined;"
                               (blur)="kontrolDeger(itm,parametreler)"
                               [ngModelOptions]="{standalone: true}" />
                    </nz-input-wrapper>
                    @if (itm.degeri) {
                    <div class="flex align-items-center gap-2 mt-1">
                        <nz-tag nzColor="purple"><nz-icon nzType="qrcode" /> QR Kod</nz-tag>
                        <span class="text-black-alpha-60" style="font-family: monospace; font-size: 12px;">{{ itm.degeri }}</span>
                        <button nz-button nzSize="small" nzType="link" (click)="panoyaKopyala(itm.degeri)">Kopyala</button>
                    </div>
                    }
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("BarKod") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '📊'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <input nz-input [placeholder]="itm.yerTutucu ?? 'Barkod değeri'" [name]="itm.ismi" [(ngModel)]="itm.degeri"
                               [disabled]="itm?.ayarlar?.sadeceOkunur ?? false"
                               (ngModelChange)="itm?.ayarlar?.olaylar?.degisti ? olayDegisti(itm, $event, parametreler):undefined;"
                               (blur)="kontrolDeger(itm,parametreler)"
                               [ngModelOptions]="{standalone: true}" />
                    </nz-input-wrapper>
                    @if (itm.degeri) {
                    <div class="flex align-items-center gap-2 mt-1">
                        <nz-tag nzColor="orange"><nz-icon nzType="barcode" /> Barkod</nz-tag>
                        <span class="text-black-alpha-60" style="font-family: monospace; font-size: 14px; letter-spacing: 2px;">{{ itm.degeri }}</span>
                        <button nz-button nzSize="small" nzType="link" (click)="panoyaKopyala(itm.degeri)">Kopyala</button>
                    </div>
                    }
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Otomatik Kod") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper nzPrefix="#" class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzSuffix]="otomatikKodSuffix"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <input nz-input [placeholder]="itm.yerTutucu ?? 'Otomatik üretilecek'" [name]="itm.ismi" [(ngModel)]="itm.degeri"
                               [disabled]="itm.ayarlar?.sadeceOkunur ?? false"
                               (ngModelChange)="itm?.ayarlar?.olaylar?.degisti ? olayDegisti(itm, $event, parametreler):undefined;"
                               (blur)="kontrolDeger(itm,parametreler)"
                               [ngModelOptions]="{standalone: true}" />
                    </nz-input-wrapper>
                    <ng-template #otomatikKodSuffix>
                        <button nz-button nzSize="small" nzType="link"
                                (click)="otomatikKodUret(itm)"
                                nz-tooltip nzTooltipTitle="Yeni kod üret">
                            <span nz-icon nzType="reload" nzTheme="outline"></span>
                        </button>
                    </ng-template>
                    @if (itm.ayarlar?.kodFormat) {
                    <span class="ui aciklama text-black-alpha-60">Format: {{ itm.ayarlar.kodFormat }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Aranjman") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="flex flex-column gap-2">
                        <div class="flex flex-wrap gap-1" cdkDropList [cdkDropListData]="itm.degeri ?? []"
                             (cdkDropListDropped)="aranjmanSiraDegisti(itm, $event)">
                            @for (eleman of itm.degeri ?? []; track $index) {
                            <nz-tag cdkDrag [nzColor]="'processing'" style="cursor: move;">
                                <nz-icon nzType="holder" /> {{ eleman }}
                                @if (!itm?.ayarlar?.sadeceOkunur) {
                                <nz-icon nzType="close" style="cursor: pointer; margin-left: 4px;"
                                         (click)="aranjmanElemanSil(itm, $index)" />
                                }
                            </nz-tag>
                            }
                        </div>
                        @if (!itm?.ayarlar?.sadeceOkunur) {
                        <div class="flex gap-2">
                            <input nz-input nzSize="small"
                                   [placeholder]="itm.yerTutucu ?? 'Yeni eleman...'"
                                   #aranjmanInput
                                   (keydown.enter)="aranjmanElemanEkle(itm, aranjmanInput.value); aranjmanInput.value='';" />
                            <button nz-button nzSize="small" nzType="dashed"
                                    (click)="aranjmanElemanEkle(itm, aranjmanInput.value); aranjmanInput.value='';">
                                <nz-icon nzType="plus" /> Ekle
                            </button>
                        </div>
                        }
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("İmza") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="flex flex-column gap-2">
                        @if (itm.degeri) {
                        <div class="imza-onizleme" style="border-radius: 4px; padding: 8px; min-height: 80px;">
                            <img [src]="itm.degeri" alt="İmza" style="max-width: 100%; max-height: 120px;" />
                        </div>
                        <div class="flex gap-2">
                            <button nz-button nzSize="small" nzType="default"
                                    nz-popconfirm
                                    nzPopconfirmTitle="İmza temizlenecek. Emin misiniz?"
                                    nzOkText="Evet, Temizle"
                                    nzCancelText="Vazgeç"
                                    nzOkDanger
                                    nzPopconfirmPlacement="top"
                                    (nzOnConfirm)="imzaTemizle(itm)"
                                    [disabled]="itm?.ayarlar?.sadeceOkunur">
                                <nz-icon nzType="delete" /> Temizle
                            </button>
                        </div>
                        } @else {
                        <div class="bos-alan-placeholder" style="border-radius: 4px; padding: 24px; text-align: center; cursor: pointer; min-height: 80px;"
                             (click)="imzaBaslat(itm)">
                            <nz-icon nzType="edit" style="font-size: 24px;" />
                            <div class="text-black-alpha-40 mt-1">İmza atmak için tıklayın</div>
                        </div>
                        }
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("RichText") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="flex flex-column gap-1">
                        @if (!itm?.ayarlar?.sadeceOkunur) {
                        <div class="richtext-toolbar flex gap-1 flex-wrap"
                             class="richtext-toolbar" style="border-radius: 4px 4px 0 0; padding: 4px;">
                            <button nz-button nzSize="small" nzType="text" (click)="richTextKomut('bold')" nz-tooltip="Kalın"><b>K</b></button>
                            <button nz-button nzSize="small" nzType="text" (click)="richTextKomut('italic')" nz-tooltip="İtalik"><i>I</i></button>
                            <button nz-button nzSize="small" nzType="text" (click)="richTextKomut('underline')" nz-tooltip="Altı Çizili"><u>U</u></button>
                            <button nz-button nzSize="small" nzType="text" (click)="richTextKomut('strikeThrough')" nz-tooltip="Üstü Çizili"><s>S</s></button>
                            <nz-divider nzType="vertical"></nz-divider>
                            <button nz-button nzSize="small" nzType="text" (click)="richTextKomut('insertUnorderedList')" nz-tooltip="Liste"><nz-icon nzType="unordered-list" /></button>
                            <button nz-button nzSize="small" nzType="text" (click)="richTextKomut('insertOrderedList')" nz-tooltip="Numaralı Liste"><nz-icon nzType="ordered-list" /></button>
                        </div>
                        }
                        <div contenteditable="true"
                             [attr.contenteditable]="itm?.ayarlar?.sadeceOkunur ? 'false' : 'true'"
                             [innerHTML]="itm.degeri ?? ''"
                             (input)="itm.degeri = $event.target.innerHTML; inlineAyarDegisti();"
                             [attr.placeholder]="itm.yerTutucu ?? 'Zengin metin girin...'"
                             class="richtext-alan"
                             style="border-radius: 0 0 4px 4px; padding: 8px; min-height: 100px; outline: none; font-size: 14px;">
                        </div>
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Kod") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="flex flex-column gap-1">
                        @if (itm?.ayarlar?.dil) {
                        <nz-tag nzColor="geekblue">{{ itm.ayarlar.dil }}</nz-tag>
                        }
                        <textarea nz-input
                                  [(ngModel)]="itm.degeri"
                                  [ngModelOptions]="{standalone: true}"
                                  [disabled]="itm?.ayarlar?.sadeceOkunur ?? false"
                                  [rows]="itm?.ayarlar?.satirSayisi ?? 8"
                                  [placeholder]="itm.yerTutucu ?? '// Kodunuzu buraya yazın...'"
                                  class="kod-alani"
                                  (ngModelChange)="itm?.ayarlar?.olaylar?.degisti ? olayDegisti(itm, $event, parametreler):undefined;"
                                  (blur)="kontrolDeger(itm,parametreler)"
                                  spellcheck="false"></textarea>
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Matematik") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <nz-input-wrapper [nzPrefix]="itm?.ayarlar?.solSimge ?? '🧮'"
                                    class="flex-1 w-full"
                                    [title]="itm.ipucu ?? ''"
                                    [nzStatus]="itm?.hatalar?.length>0 ? 'error' :itm?.uyarilar?.length>0 ? 'warning':''">
                        <input nz-input [placeholder]="itm.yerTutucu ?? 'Matematiksel ifade (ör: 2*π*r)'" [name]="itm.ismi" [(ngModel)]="itm.degeri"
                               [disabled]="itm?.ayarlar?.sadeceOkunur ?? false"
                               class="kod-alani-inline"
                               (ngModelChange)="itm?.ayarlar?.olaylar?.degisti ? olayDegisti(itm, $event, parametreler):undefined;"
                               (blur)="kontrolDeger(itm,parametreler)"
                               [ngModelOptions]="{standalone: true}" />
                    </nz-input-wrapper>
                    @if (itm.degeri) {
                    <div class="flex align-items-center gap-2 mt-1">
                        <nz-tag nzColor="cyan">Sonuç</nz-tag>
                        <span class="text-black-alpha-60" style="font-family: monospace;">{{ matematikHesapla(itm.degeri) }}</span>
                    </div>
                    }
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Çizim") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="flex flex-column gap-2">
                        @if (itm.degeri) {
                        <div class="cizim-onizleme" style="border-radius: 4px; padding: 8px; min-height: 100px;">
                            <img [src]="itm.degeri" alt="Çizim" style="max-width: 100%; max-height: 200px;" />
                        </div>
                        <div class="flex gap-2">
                            <button nz-button nzSize="small" nzType="default"
                                    nz-popconfirm
                                    nzPopconfirmTitle="Çizim temizlenecek. Emin misiniz?"
                                    nzOkText="Evet, Temizle"
                                    nzCancelText="Vazgeç"
                                    nzOkDanger
                                    nzPopconfirmPlacement="top"
                                    (nzOnConfirm)="cizimTemizle(itm)"
                                    [disabled]="itm?.ayarlar?.sadeceOkunur">
                                <nz-icon nzType="delete" /> Temizle
                            </button>
                        </div>
                        } @else {
                        <div class="bos-alan-placeholder" style="border-radius: 4px; padding: 24px; text-align: center; cursor: pointer; min-height: 100px;"
                             (click)="cizimBaslat(itm)">
                            <nz-icon nzType="highlight" style="font-size: 24px;" />
                            <div class="text-black-alpha-40 mt-1">Çizim yapmak için tıklayın</div>
                        </div>
                        }
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Sürükle Bırak") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="flex flex-column gap-2"
                         (dragover)="$event.preventDefault()"
                         (drop)="dosyaSurukBirakBirakildi(itm, $event)">
                        @if (itm.degeri?.dosya) {
                        <div class="flex align-items-center gap-2 dosya-gosterge" style="border-radius: 4px; padding: 8px;">
                            <nz-icon nzType="file" style="font-size: 20px; color: #1890ff;" />
                            <span class="flex-1">{{ itm.degeri.dosya.name }} ({{ (itm.degeri.dosya.size / 1024).toFixed(1) }} KB)</span>
                            @if (!itm?.ayarlar?.sadeceOkunur) {
                            <button nz-button nzSize="small" nzType="text" nzDanger
                                    (click)="itm.degeri = null; inlineAyarDegisti();">
                                <nz-icon nzType="delete" />
                            </button>
                            }
                        </div>
                        } @else {
                        <div class="bos-alan-placeholder" style="border-radius: 8px; padding: 32px; text-align: center; cursor: pointer; transition: border-color 0.3s;"
                             (click)="dosyaSurukBirakSec(itm)">
                            <nz-icon nzType="cloud-upload" style="font-size: 32px;" />
                            <div class="text-black-alpha-40 mt-2">Dosyayı sürükleyip bırakın veya tıklayın</div>
                        </div>
                        }
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Dosya Yükleme") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="flex flex-column gap-2">
                        @if (itm.degeri?.dosyalar?.length > 0) {
                        <div class="flex flex-column gap-1">
                            @for (dosya of itm.degeri.dosyalar; track $index) {
                            <div class="flex align-items-center gap-2 dosya-liste-item" style="border-radius: 4px; padding: 4px 8px;">
                                <nz-icon nzType="paper-clip" />
                                <span class="flex-1" style="font-size: 12px;">{{ dosya.name }} ({{ (dosya.size / 1024).toFixed(1) }} KB)</span>
                                @if (!itm?.ayarlar?.sadeceOkunur) {
                                <button nz-button nzSize="small" nzType="text" nzDanger
                                        (click)="dosyaYuklemeSil(itm, $index)">
                                    <nz-icon nzType="delete" />
                                </button>
                                }
                            </div>
                            }
                        </div>
                        }
                        @if (!itm?.ayarlar?.sadeceOkunur) {
                        <div class="bos-alan-placeholder" style="border-radius: 8px; padding: 24px; text-align: center; cursor: pointer;"
                             (click)="dosyaYuklemeSecDegistir(itm)"
                             (dragover)="$event.preventDefault()"
                             (drop)="dosyaYuklemeSurukBirak(itm, $event)">
                            <nz-icon nzType="upload" style="font-size: 24px; color: #1890ff;" />
                            <div class="text-black-alpha-60 mt-1">Dosya yüklemek için tıklayın veya sürükleyin</div>
                            @if (itm?.ayarlar?.accept) {
                            <div class="text-black-alpha-30" style="font-size: 11px;">Kabul: {{ itm.ayarlar.accept }}</div>
                            }
                        </div>
                        }
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("XYZ") {
                    <label class="ui font-bold text-primary">{{ itm?.baslik ?? "" }}</label>
                    <div class="xyz-satir" [title]="itm.ipucu ?? ''" (onInit)="xyzBaslat(itm)">
                        <nz-input-wrapper nzSize="small" nzAddonBefore="X" class="xyz-alan">
                            <input nz-input nzSize="small" type="number" placeholder="X"
                                   [(ngModel)]="itm.degeri.x" [min]="itm?.ayarlar?.min?.x"
                                   [max]="itm?.ayarlar?.maks?.x" [step]="itm?.ayarlar?.adim?.x ?? 0.1"
                                   [ngModelOptions]="{standalone: true}"
                                   (ngModelChange)="itm?.ayarlar?.olaylar?.degisti ? olayDegisti(itm, $event, parametreler):undefined;" />
                        </nz-input-wrapper>
                        <nz-input-wrapper nzSize="small" nzAddonBefore="Y" class="xyz-alan">
                            <input nz-input nzSize="small" type="number" placeholder="Y"
                                   [(ngModel)]="itm.degeri.y" [min]="itm?.ayarlar?.min?.y"
                                   [max]="itm?.ayarlar?.maks?.y" [step]="itm?.ayarlar?.adim?.y ?? 0.1"
                                   [ngModelOptions]="{standalone: true}"
                                   (ngModelChange)="itm?.ayarlar?.olaylar?.degisti ? olayDegisti(itm, $event, parametreler):undefined;" />
                        </nz-input-wrapper>
                        <nz-input-wrapper nzSize="small" nzAddonBefore="Z" class="xyz-alan">
                            <input nz-input nzSize="small" type="number" placeholder="Z"
                                   [(ngModel)]="itm.degeri.z" [min]="itm?.ayarlar?.min?.z"
                                   [max]="itm?.ayarlar?.maks?.z" [step]="itm?.ayarlar?.adim?.z ?? 0.1"
                                   [ngModelOptions]="{standalone: true}"
                                   (ngModelChange)="itm?.ayarlar?.olaylar?.degisti ? olayDegisti(itm, $event, parametreler):undefined;" />
                        </nz-input-wrapper>
                    </div>
                    <span class="ui aciklama text-black-alpha-60">{{ itm.altAciklama }}</span>
                    @for (uyr of itm.uyarilar; track $index) {
                    <span class="ui {{ uyr.renk ?? 'orange' }} label text fluid hata"
                          (click)="itm.uyarilar.splice($index,1);">{{ uyr.mesaj }}</span>
                    }
                    @for (hata of itm.hatalar; track $index) {
                    <span class="ui {{ hata.renk ?? 'red' }} label text fluid hata">{{ hata.mesaj }}</span>
                    }
                    }

                    @case ("Dinamik Bileşen") {
                    <dinamik-bilesen
                        [bilesenId]="itm.ayarlar?.bilesenId"
                        [gorunum]="itm.ayarlar?.gorunum || 'parametre'"
                        [(parametreler)]="itm.degeri"
                    />
                    }

                    @case ("Dosya Kutusu") {
                    <dosya-kutusu [(deger)]="itm.degeri" [ayarlar]="itm.ayarlar" [sadeceOkunur]="!!itm?.ayarlar?.sadeceOkunur" />
                    }

                    @case ("Grup") {
                    <div class="ui accordion" style="margin-left: 1rem;">
                        <div class="active title">
                            <i class="dropdown icon"></i>
                            {{ itm?.baslik ?? "" }}
                        </div>
                        <div class="active content"
                             style="border: 1px solid var(--py-bolucu);padding:1rem;margin: 0 0 0 0;">
                            <ng-container *ngTemplateOutlet="recursiveParametre; context:{ $implicit: itm.degeri }">
                            </ng-container>
                        </div>
                    </div>
                    }

                    }

                    }

                </div>



                }
            </ng-container>
            </div><!-- /cdkDropList -->
        </ng-template>

        <div [class]="gorunumModu === 'kart' ? 'prm-kart-grid' : ''">
          <ng-container *ngTemplateOutlet="recursiveParametre; context:{ $implicit: parametreler }"></ng-container>
        </div>

<!-- Hızlı Ekleme Modalı (Paylaş Kutusu — lazy load) -->
<nz-modal [nzVisible]="_hizliEkleAcik"
          [nzTitle]="'Yeni ' + (_hizliEkleItm?.ayarlar?.hizliEkle || '') + ' Ekle'"
          [nzWidth]="600"
          [nzFooter]="null"
          (nzOnCancel)="hizliEkleIptal()">
  <ng-container *nzModalContent>
    <ng-container #hizliEkleKonteynir></ng-container>
  </ng-container>
</nz-modal>

<!-- Parametre Ayar Modalı -->
<nz-modal [(nzVisible)]="ayarModalAcik"
          [nzTitle]="(ayarModalItm?.baslik || ayarModalItm?.ismi || 'Parametre') + ' Ayarları'"
          [nzWidth]="600"
          nzCentered
          (nzOnCancel)="ayarModalKapat()"
          [nzFooter]="ayarModalFooterTpl">
  <ng-container *nzModalContent>
  @if (ayarModalItm; as itm) {
    <nz-tabs nzSize="small" nzType="card" nzAnimated>

      <!-- GENEL -->
      <nz-tab nzTitle="Genel">
        <div class="ayar-grup">
          <div class="ayar-alan">
            <span class="ayar-etiket">Parametre Turu</span>
            <nz-select nzSize="small" [(ngModel)]="itm.turu"
                       [ngModelOptions]="{standalone: true}"
                       nzShowSearch nzPlaceHolder="Tur secin"
                       (ngModelChange)="turDegistir(itm, $event)">
              @for (tur of tumTurler; track tur) {
                <nz-option [nzValue]="tur" [nzLabel]="getParametreIkonu(tur) + ' ' + tur"></nz-option>
              }
            </nz-select>
          </div>
          <div class="ayar-satir-flags">
            <label nz-checkbox [(ngModel)]="itm.ayarlar.zorunlu"
                   [ngModelOptions]="{standalone: true}"
                   (ngModelChange)="inlineAyarDegisti()">Zorunlu</label>
            <label nz-checkbox [(ngModel)]="itm.ayarlar.sadeceOkunur"
                   [ngModelOptions]="{standalone: true}"
                   (ngModelChange)="inlineAyarDegisti()">Salt Okunur</label>
            <label nz-checkbox [(ngModel)]="itm.ayarlar.gorunur"
                   [ngModelOptions]="{standalone: true}"
                   (ngModelChange)="inlineAyarDegisti()">Gorunur</label>
          </div>
          <div class="ayar-grid-2">
            <div class="ayar-alan">
              <span class="ayar-etiket">Baslik</span>
              <input nz-input nzSize="small" [(ngModel)]="itm.baslik"
                     [ngModelOptions]="{standalone: true}" placeholder="Parametre basligi"
                     (ngModelChange)="inlineAyarDegisti()" />
            </div>
            <div class="ayar-alan">
              <span class="ayar-etiket">Teknik Isim</span>
              <input nz-input nzSize="small" [(ngModel)]="itm.ismi"
                     [ngModelOptions]="{standalone: true}" placeholder="parametre_ismi"
                     class="kod-alani-inline"
                     (ngModelChange)="inlineAyarDegisti()" />
            </div>
          </div>
          <div class="ayar-alan">
            <span class="ayar-etiket">Alt Aciklama</span>
            <input nz-input nzSize="small" [(ngModel)]="itm.altAciklama"
                   [ngModelOptions]="{standalone: true}" placeholder="Kullaniciya gosterilecek aciklama"
                   (ngModelChange)="inlineAyarDegisti()" />
          </div>
          <div class="ayar-grid-2">
            <div class="ayar-alan">
              <span class="ayar-etiket">Ipucu (Tooltip)</span>
              <input nz-input nzSize="small" [(ngModel)]="itm.ipucu"
                     [ngModelOptions]="{standalone: true}" placeholder="Tooltip metni"
                     (ngModelChange)="inlineAyarDegisti()" />
            </div>
            <div class="ayar-alan">
              <span class="ayar-etiket">Yer Tutucu</span>
              <input nz-input nzSize="small" [(ngModel)]="itm.yerTutucu"
                     [ngModelOptions]="{standalone: true}" placeholder="Placeholder metin"
                     (ngModelChange)="inlineAyarDegisti()" />
            </div>
          </div>
          <div class="ayar-alan">
            <span class="ayar-etiket">Sol Simge</span>
            <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.solSimge"
                   [ngModelOptions]="{standalone: true}" placeholder="Simge (emoji veya ikon sinifi)"
                   (ngModelChange)="inlineAyarDegisti()" />
          </div>
        </div>
      </nz-tab>

      <!-- KISITLAMA -->
      <nz-tab nzTitle="Kisitlama">
        <div class="ayar-grup">
          <div class="ayar-grid-3">
            <div class="ayar-alan">
              <span class="ayar-etiket">Min</span>
              <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.min"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()" />
            </div>
            <div class="ayar-alan">
              <span class="ayar-etiket">Maks</span>
              <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.maks"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()" />
            </div>
            <div class="ayar-alan">
              <span class="ayar-etiket">Adim</span>
              <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.adim"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()" />
            </div>
          </div>
          <div class="ayar-alan">
            <span class="ayar-etiket">Format</span>
            <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.format"
                   [ngModelOptions]="{standalone: true}" placeholder="Orn: dd.MM.yyyy, #.##"
                   (ngModelChange)="inlineAyarDegisti()" />
          </div>
          @if (itm.turu === 'Resim' || itm.turu === 'Video' || itm.turu === 'Ses' || itm.turu === 'Dosya' || itm.turu === 'Dosya Yükleme') {
            <div class="ayar-alan">
              <span class="ayar-etiket">Maks Dosya Boyutu (MB)</span>
              <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.maksBoyutMb"
                     [ngModelOptions]="{standalone: true}" placeholder="10"
                     (ngModelChange)="inlineAyarDegisti()" />
            </div>
          }
        </div>
      </nz-tab>

      <!-- TURE OZEL -->
      <nz-tab nzTitle="Ture Ozel">
        <div class="ayar-grup">

          @if (itm.turu === 'Yazı Alanı') {
            <div class="ayar-alan">
              <span class="ayar-etiket">Satir Sayisi</span>
              <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.satirSayisi"
                     [ngModelOptions]="{standalone: true}" placeholder="3"
                     (ngModelChange)="inlineAyarDegisti()" />
            </div>
          }

          @if (itm.turu === 'Açılır Kutu') {
            <div class="ayar-satir-flags">
              <label nz-checkbox [(ngModel)]="itm.ayarlar.arama"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Aranabilir</label>
              <label nz-checkbox [(ngModel)]="itm.ayarlar.coklu"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Coklu Secim</label>
              <label nz-checkbox [(ngModel)]="itm.ayarlar.silme"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Temizlenebilir</label>
            </div>

            <div class="ayar-alan">
              <div class="ayar-etiket-satir">
                <span class="ayar-etiket">Ozel Item Tasarimi</span>
                <label nz-checkbox [ngModel]="!!itm.ayarlar?.itemSablon?.aktif"
                       [ngModelOptions]="{standalone: true}"
                       (ngModelChange)="itemSablonToggle(itm)"></label>
              </div>
              @if (itm.ayarlar?.itemSablon?.aktif) {
                <div class="ayar-satir-flags">
                  <label nz-checkbox [(ngModel)]="itm.ayarlar.itemSablon.simgeGoster"
                         [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Simge</label>
                  <label nz-checkbox [(ngModel)]="itm.ayarlar.itemSablon.renkGoster"
                         [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Renk</label>
                  <label nz-checkbox [(ngModel)]="itm.ayarlar.itemSablon.aciklamaGoster"
                         [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Aciklama</label>
                  <label nz-checkbox [(ngModel)]="itm.ayarlar.itemSablon.resimGoster"
                         [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Resim</label>
                </div>
              }
            </div>

            <div class="ayar-alan">
              <div class="ayar-etiket-satir">
                <span class="ayar-etiket">Secenekler</span>
                <button nz-button nzSize="small" nzType="dashed"
                        (click)="inlineSecenekEkle(itm, 'acilirKutu')">+ Ekle</button>
              </div>
              @for (s of itm.ayarlar?.secenekler ?? []; track $index) {
                <div class="secenek-satir">
                  <input nz-input nzSize="small" [(ngModel)]="s.label"
                         [ngModelOptions]="{standalone: true}" placeholder="Etiket"
                         (ngModelChange)="inlineAyarDegisti()" />
                  <input nz-input nzSize="small" [(ngModel)]="s.value"
                         [ngModelOptions]="{standalone: true}" placeholder="Deger"
                         (ngModelChange)="inlineAyarDegisti()" />
                  @if (itm.ayarlar?.itemSablon?.aktif) {
                    @if (itm.ayarlar.itemSablon.simgeGoster) {
                      <input nz-input nzSize="small" [(ngModel)]="s.simge"
                             [ngModelOptions]="{standalone: true}" placeholder="&#128309;"
                             style="width: 48px; text-align: center;"
                             (ngModelChange)="inlineAyarDegisti()" />
                    }
                    @if (itm.ayarlar.itemSablon.renkGoster) {
                      <input nz-input nzSize="small" type="color" [(ngModel)]="s.renk"
                             [ngModelOptions]="{standalone: true}" style="width: 36px; padding: 1px;"
                             (ngModelChange)="inlineAyarDegisti()" />
                    }
                    @if (itm.ayarlar.itemSablon.aciklamaGoster) {
                      <input nz-input nzSize="small" [(ngModel)]="s.aciklama"
                             [ngModelOptions]="{standalone: true}" placeholder="Aciklama"
                             (ngModelChange)="inlineAyarDegisti()" />
                    }
                    @if (itm.ayarlar.itemSablon.resimGoster) {
                      <input nz-input nzSize="small" [(ngModel)]="s.resimUrl"
                             [ngModelOptions]="{standalone: true}" placeholder="Resim URL"
                             (ngModelChange)="inlineAyarDegisti()" />
                    }
                  }
                  <button nz-button nzSize="small" nzType="text" nzDanger
                          (click)="inlineSecenekSil(itm, $index)">
                    <nz-icon nzType="delete" />
                  </button>
                </div>
              }
            </div>

            <div class="ayar-alan">
              <label nz-checkbox [ngModel]="!!itm.ayarlar?.fapiAyarlar"
                     [ngModelOptions]="{standalone: true}"
                     (ngModelChange)="inlineFapiToggle(itm)">Sunucu API (FAPI)</label>
              @if (itm.ayarlar?.fapiAyarlar) {
                <div class="ayar-grid-2" style="margin-top: 6px;">
                  <div class="ayar-alan">
                    <span class="ayar-etiket">VT</span>
                    <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.fapiAyarlar.vt"
                           [ngModelOptions]="{standalone: true}" placeholder="FikoYT.Uyar.firmalar"
                           (ngModelChange)="inlineAyarDegisti()" />
                  </div>
                  <div class="ayar-alan">
                    <span class="ayar-etiket">Yol</span>
                    <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.fapiAyarlar.yol"
                           [ngModelOptions]="{standalone: true}" placeholder="FikoYT.Uyar.firmalar.kalem"
                           (ngModelChange)="inlineAyarDegisti()" />
                  </div>
                </div>
                <div class="ayar-alan" style="margin-top: 6px;">
                  <span class="ayar-etiket">Pipe Fonksiyonu</span>
                  <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.fapiAyarlar.pipeFunc"
                            [ngModelOptions]="{standalone: true}" rows="3" class="kod-alani"
                            placeholder="return [ { $match: { ... } } ];"
                            (ngModelChange)="inlineAyarDegisti()"></textarea>
                </div>
                <div class="ayar-alan" style="margin-top: 6px;">
                  <span class="ayar-etiket">Secenek Item Fonksiyonu</span>
                  <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.secenekItm"
                            [ngModelOptions]="{standalone: true}" rows="2" class="kod-alani"
                            placeholder="return { label: scnk.veri?.ismi, value: scnk._id };"
                            (ngModelChange)="inlineAyarDegisti()"></textarea>
                </div>
              }
            </div>
          }

          @if (itm.turu === 'Renk') {
            <div class="ayar-alan">
              <span class="ayar-etiket">Renk Formati</span>
              <nz-select nzSize="small" [(ngModel)]="itm.ayarlar.format"
                         [ngModelOptions]="{standalone: true}" nzPlaceHolder="Format sec"
                         (ngModelChange)="inlineAyarDegisti()">
                <nz-option nzValue="hex" nzLabel="HEX (#FF0000)"></nz-option>
                <nz-option nzValue="rgb" nzLabel="RGB"></nz-option>
                <nz-option nzValue="rgba" nzLabel="RGBA"></nz-option>
                <nz-option nzValue="hsl" nzLabel="HSL"></nz-option>
              </nz-select>
            </div>
            <label nz-checkbox [(ngModel)]="itm.ayarlar.seffaf"
                   [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Seffaflik Destegi</label>
          }

          @if (itm.turu === 'İlerleme Çubuğu') {
            <div class="ayar-satir-flags">
              <label nz-checkbox [(ngModel)]="itm.ayarlar.yuzdeGoster"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Yuzde Goster</label>
              <label nz-checkbox [(ngModel)]="itm.ayarlar.animasyon"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Animasyon</label>
            </div>
            <div class="ayar-grid-2">
              <div class="ayar-alan">
                <span class="ayar-etiket">Cubuk Rengi</span>
                <input nz-input nzSize="small" type="color" [(ngModel)]="itm.ayarlar.renk"
                       [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()" />
              </div>
              <div class="ayar-alan">
                <span class="ayar-etiket">Arka Plan Rengi</span>
                <input nz-input nzSize="small" type="color" [(ngModel)]="itm.ayarlar.arkaPlanRenk"
                       [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()" />
              </div>
            </div>
          }

          @if (itm.turu === 'Oylama') {
            <div class="ayar-satir-flags">
              <label nz-checkbox [(ngModel)]="itm.ayarlar.anonim"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Anonim</label>
              <label nz-checkbox [(ngModel)]="itm.ayarlar.sonuclarGorunur"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Sonuclar Gorunur</label>
              <label nz-checkbox [(ngModel)]="itm.ayarlar.birdenFazlaSecim"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Birden Fazla Secim</label>
            </div>
            <div class="ayar-alan">
              <div class="ayar-etiket-satir">
                <span class="ayar-etiket">Secenekler</span>
                <button nz-button nzSize="small" nzType="dashed"
                        (click)="inlineSecenekEkle(itm, 'oylama')">+ Ekle</button>
              </div>
              @for (s of itm.ayarlar?.secenekler ?? []; track $index) {
                <div class="secenek-satir">
                  <input nz-input nzSize="small" [(ngModel)]="s.etiket"
                         [ngModelOptions]="{standalone: true}" placeholder="Etiket"
                         (ngModelChange)="inlineAyarDegisti()" />
                  <input nz-input nzSize="small" [(ngModel)]="s.deger"
                         [ngModelOptions]="{standalone: true}" placeholder="Deger"
                         (ngModelChange)="inlineAyarDegisti()" />
                  <input nz-input nzSize="small" type="color" [(ngModel)]="s.renk"
                         [ngModelOptions]="{standalone: true}" style="width: 40px; padding: 0;"
                         (ngModelChange)="inlineAyarDegisti()" />
                  <button nz-button nzSize="small" nzType="text" nzDanger
                          (click)="inlineSecenekSil(itm, $index)">
                    <nz-icon nzType="delete" />
                  </button>
                </div>
              }
            </div>
          }

          @if (itm.turu === 'Konum') {
            <div class="ayar-grid-2">
              <div class="ayar-alan">
                <span class="ayar-etiket">Zoom Seviyesi</span>
                <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.zoom"
                       [ngModelOptions]="{standalone: true}" placeholder="15"
                       (ngModelChange)="inlineAyarDegisti()" />
              </div>
              <div class="ayar-alan">
                <span class="ayar-etiket">Harita Turu</span>
                <nz-select nzSize="small" [(ngModel)]="itm.ayarlar.haritaTuru"
                           [ngModelOptions]="{standalone: true}" nzPlaceHolder="Sec"
                           (ngModelChange)="inlineAyarDegisti()">
                  <nz-option nzValue="standart" nzLabel="Standart"></nz-option>
                  <nz-option nzValue="uydu" nzLabel="Uydu"></nz-option>
                  <nz-option nzValue="hibrit" nzLabel="Hibrit"></nz-option>
                </nz-select>
              </div>
            </div>
            <label nz-checkbox [(ngModel)]="itm.ayarlar.otomatikKonum"
                   [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Otomatik Konum Al</label>
          }

          @if (itm.turu === 'Zaman Aralığı') {
            <div class="ayar-alan">
              <span class="ayar-etiket">Tarih Formati</span>
              <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.tarihFormat"
                     [ngModelOptions]="{standalone: true}" placeholder="dd.MM.yyyy"
                     (ngModelChange)="inlineAyarDegisti()" />
            </div>
          }

          @if (itm.turu === 'Sekme') {
            <label nz-checkbox [(ngModel)]="itm.ayarlar.jsonGrup"
                   [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">JSON Gruplama</label>
          }

          @if (itm.turu === 'Resim' || itm.turu === 'Video' || itm.turu === 'Ses' || itm.turu === 'Dosya' || itm.turu === 'Dosya Yükleme' || itm.turu === 'Sürükle Bırak') {
            <div class="ayar-grid-2">
              <div class="ayar-alan">
                <span class="ayar-etiket">Maks Boyut (MB)</span>
                <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.maksBoyutMb"
                       [ngModelOptions]="{standalone: true}" placeholder="10"
                       (ngModelChange)="inlineAyarDegisti()" />
              </div>
              <div class="ayar-alan">
                <span class="ayar-etiket">Kabul Tipleri</span>
                <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.accept"
                       [ngModelOptions]="{standalone: true}" placeholder="image/*,video/*,.pdf"
                       (ngModelChange)="inlineAyarDegisti()" />
              </div>
            </div>
          }

          @if (itm.turu === 'Para') {
            <div class="ayar-alan">
              <span class="ayar-etiket">Para Birimi</span>
              <nz-select nzSize="small" [(ngModel)]="itm.ayarlar.paraBirimi"
                         [ngModelOptions]="{standalone: true}" nzPlaceHolder="Para birimi sec" nzShowSearch
                         (ngModelChange)="inlineAyarDegisti()">
                <nz-option nzValue="TRY" nzLabel="TRY - Turk Lirasi"></nz-option>
                <nz-option nzValue="USD" nzLabel="$ USD - ABD Dolari"></nz-option>
                <nz-option nzValue="EUR" nzLabel="EUR - Euro"></nz-option>
                <nz-option nzValue="GBP" nzLabel="GBP - Ingiliz Sterlini"></nz-option>
              </nz-select>
            </div>
          }

          @if (itm.turu === 'Liste') {
            <div class="ayar-satir-flags">
              <label nz-checkbox [(ngModel)]="itm.ayarlar.coklu"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Coklu Secim</label>
              <label nz-checkbox [(ngModel)]="itm.ayarlar.siralama"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Siralanabilir</label>
            </div>
          }

          @if (itm.turu === 'Tablo') {
            <div class="ayar-alan">
              <span class="ayar-etiket">Kolon Isimleri</span>
              <input nz-input nzSize="small" [(ngModel)]="itm.ayarlar.kolonlarStr"
                     [ngModelOptions]="{standalone: true}" placeholder="Kolon1, Kolon2, Kolon3 (virgulle ayirin)"
                     (ngModelChange)="tabloKolonlarGuncelle(itm, $event)" />
            </div>
            <div class="ayar-satir-flags">
              <label nz-checkbox [(ngModel)]="itm.ayarlar.satirEkleme"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Satir Ekleme</label>
              <label nz-checkbox [(ngModel)]="itm.ayarlar.satirSilme"
                     [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">Satir Silme</label>
            </div>
          }

          @if (itm.turu === 'KareKod') {
            <div class="ayar-alan">
              <span class="ayar-etiket">QR Kod Boyutu</span>
              <nz-select nzSize="small" [(ngModel)]="itm.ayarlar.boyut"
                         [ngModelOptions]="{standalone: true}" nzPlaceHolder="Boyut"
                         (ngModelChange)="inlineAyarDegisti()">
                <nz-option nzValue="small" nzLabel="Kucuk (128px)"></nz-option>
                <nz-option nzValue="medium" nzLabel="Orta (256px)"></nz-option>
                <nz-option nzValue="large" nzLabel="Buyuk (512px)"></nz-option>
              </nz-select>
            </div>
          }

          @if (itm.turu === 'BarKod') {
            <div class="ayar-alan">
              <span class="ayar-etiket">Barkod Formati</span>
              <nz-select nzSize="small" [(ngModel)]="itm.ayarlar.barkodFormat"
                         [ngModelOptions]="{standalone: true}" nzPlaceHolder="Format"
                         (ngModelChange)="inlineAyarDegisti()">
                <nz-option nzValue="CODE128" nzLabel="CODE128"></nz-option>
                <nz-option nzValue="EAN13" nzLabel="EAN-13"></nz-option>
                <nz-option nzValue="EAN8" nzLabel="EAN-8"></nz-option>
                <nz-option nzValue="UPC" nzLabel="UPC"></nz-option>
                <nz-option nzValue="CODE39" nzLabel="CODE39"></nz-option>
                <nz-option nzValue="ITF14" nzLabel="ITF-14"></nz-option>
              </nz-select>
            </div>
          }

          @if (itm.turu === 'Kod') {
            <div class="ayar-grid-2">
              <div class="ayar-alan">
                <span class="ayar-etiket">Programlama Dili</span>
                <nz-select nzSize="small" [(ngModel)]="itm.ayarlar.dil"
                           [ngModelOptions]="{standalone: true}" nzPlaceHolder="Dil" nzShowSearch
                           (ngModelChange)="inlineAyarDegisti()">
                  <nz-option nzValue="typescript" nzLabel="TypeScript"></nz-option>
                  <nz-option nzValue="javascript" nzLabel="JavaScript"></nz-option>
                  <nz-option nzValue="python" nzLabel="Python"></nz-option>
                  <nz-option nzValue="go" nzLabel="Go"></nz-option>
                  <nz-option nzValue="rust" nzLabel="Rust"></nz-option>
                  <nz-option nzValue="html" nzLabel="HTML"></nz-option>
                  <nz-option nzValue="css" nzLabel="CSS"></nz-option>
                  <nz-option nzValue="sql" nzLabel="SQL"></nz-option>
                  <nz-option nzValue="json" nzLabel="JSON"></nz-option>
                  <nz-option nzValue="yaml" nzLabel="YAML"></nz-option>
                </nz-select>
              </div>
              <div class="ayar-alan">
                <span class="ayar-etiket">Satir Sayisi</span>
                <input nz-input nzSize="small" type="number" [(ngModel)]="itm.ayarlar.satirSayisi"
                       [ngModelOptions]="{standalone: true}" placeholder="8"
                       (ngModelChange)="inlineAyarDegisti()" />
              </div>
            </div>
          }

        </div>
      </nz-tab>

      <!-- OLAYLAR -->
      <nz-tab nzTitle="Olaylar">
        <div class="ayar-grup">
          <div class="olay-bilgi-bar">
            <nz-tag nzColor="geekblue">TypeScript</nz-tag>
            <span class="ayar-bilgi-metin">Parametreler: form, prm, itm, deger</span>
          </div>
          <div class="ayar-alan">
            <div class="ayar-etiket-satir">
              <span class="ayar-etiket">Degisti</span>
              @if (itm.ayarlar.olaylar.degisti) {
                <button nz-button nzSize="small" nzType="link" (click)="kodTest(itm, 'degisti')">
                  <nz-icon nzType="play-circle" /> Test
                </button>
              }
            </div>
            <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.olaylar.degisti"
                      [ngModelOptions]="{standalone: true}" rows="3" class="kod-alani"
                      placeholder="// Deger degistiginde calisir"
                      (ngModelChange)="inlineAyarDegisti()"></textarea>
          </div>
          <div class="ayar-alan">
            <div class="ayar-etiket-satir">
              <span class="ayar-etiket">Secildi</span>
              @if (itm.ayarlar.olaylar.secildi) {
                <button nz-button nzSize="small" nzType="link" (click)="kodTest(itm, 'secildi')">
                  <nz-icon nzType="play-circle" /> Test
                </button>
              }
            </div>
            <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.olaylar.secildi"
                      [ngModelOptions]="{standalone: true}" rows="3" class="kod-alani"
                      placeholder="// Acilir kutu secim olayinda calisir"
                      (ngModelChange)="inlineAyarDegisti()"></textarea>
          </div>
          <div class="ayar-grid-2">
            <div class="ayar-alan">
              <span class="ayar-etiket">Focus</span>
              <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.olaylar.focus"
                        [ngModelOptions]="{standalone: true}" rows="2" class="kod-alani"
                        placeholder="// focus olayinda calisir"
                        (ngModelChange)="inlineAyarDegisti()"></textarea>
            </div>
            <div class="ayar-alan">
              <span class="ayar-etiket">Blur</span>
              <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.olaylar.blur"
                        [ngModelOptions]="{standalone: true}" rows="2" class="kod-alani"
                        placeholder="// blur olayinda calisir"
                        (ngModelChange)="inlineAyarDegisti()"></textarea>
            </div>
          </div>
          <div class="ayar-alan formul-ayirici" style="margin-top: 8px; padding-top: 8px;">
            <div class="ayar-etiket-satir">
              <span class="ayar-etiket">Formul (Hesaplanan Deger)</span>
              @if (itm.ayarlar?.formul) {
                <button nz-button nzSize="small" nzType="link" (click)="formulDegerlendir(itm)">
                  <nz-icon nzType="thunderbolt" /> Hesapla
                </button>
              }
            </div>
            <textarea nz-input nzSize="small" [(ngModel)]="itm.ayarlar.formul"
                      [ngModelOptions]="{standalone: true}" rows="2" class="kod-alani"
                      placeholder="// return prm.fiyat * prm.adet;"
                      (ngModelChange)="inlineAyarDegisti()"></textarea>
          </div>
        </div>
      </nz-tab>

      <!-- KONTROLLER -->
      <nz-tab nzTitle="Kontroller">
        <div class="ayar-grup">
          <div class="ayar-etiket-satir">
            <span class="ayar-etiket">Dogrulama Kurallari</span>
            <button nz-button nzSize="small" nzType="dashed"
                    (click)="inlineKontrolEkle(itm)">+ Kural Ekle</button>
          </div>
          @for (key of kontrolAnahtarlari(itm); track key) {
            <div class="kontrol-satir">
              <div class="ayar-alan" style="flex: 2;">
                <span class="ayar-etiket">Fonksiyon (TypeScript)</span>
                <textarea nz-input nzSize="small" [(ngModel)]="itm.kontroller[key].fn"
                          [ngModelOptions]="{standalone: true}" rows="3" class="kod-alani"
                          placeholder="// return false; -> dogrulama basarisiz"
                          (ngModelChange)="inlineAyarDegisti()"></textarea>
              </div>
              <div class="ayar-alan" style="flex: 1;">
                <span class="ayar-etiket">Hata Mesaji</span>
                <input nz-input nzSize="small" [(ngModel)]="itm.kontroller[key].mesaj"
                       [ngModelOptions]="{standalone: true}" placeholder="Hata mesaji"
                       (ngModelChange)="inlineAyarDegisti()" />
              </div>
              <div class="kontrol-aksiyonlar">
                <nz-select nzSize="small" [(ngModel)]="itm.kontroller[key].renk"
                           [ngModelOptions]="{standalone: true}" style="width: 80px;"
                           (ngModelChange)="inlineAyarDegisti()">
                  <nz-option nzValue="red" nzLabel="Kirmizi"></nz-option>
                  <nz-option nzValue="orange" nzLabel="Turuncu"></nz-option>
                  <nz-option nzValue="yellow" nzLabel="Sari"></nz-option>
                </nz-select>
                <button nz-button nzSize="small" nzType="link"
                        (click)="kontrolTest(itm, key)" nz-tooltip nzTooltipTitle="Kurali test et">
                  <nz-icon nzType="play-circle" />
                </button>
                <button nz-button nzSize="small" nzType="text" nzDanger
                        (click)="inlineKontrolSil(itm, key)">
                  <nz-icon nzType="delete" />
                </button>
              </div>
            </div>
          }
          @if (kontrolAnahtarlari(itm).length === 0) {
            <div class="ayar-bilgi">
              <span class="ayar-bilgi-metin">Henuz dogrulama kurali eklenmemis.</span>
            </div>
          }
        </div>
      </nz-tab>

      <!-- BAGIMLILIKLAR -->
      <nz-tab nzTitle="Bagimlilik">
        <div class="ayar-grup">
          <div class="ayar-etiket-satir">
            <span class="ayar-etiket">Parametre Bagimliliklari</span>
            <button nz-button nzSize="small" nzType="dashed"
                    (click)="bagimlilikEkle(itm)">+ Bagimlilik Ekle</button>
          </div>
          <div class="ayar-bilgi" style="margin-bottom: 6px;">
            <nz-tag nzColor="purple">Kosullu Gorunurluk</nz-tag>
            <span class="ayar-bilgi-metin">Baska parametrelerin degerine gore bu parametrenin davranisini belirleyin.</span>
          </div>
          @for (bag of itm.ayarlar?.bagimliliklar ?? []; track $index) {
            <div class="kontrol-satir">
              <div class="ayar-alan" style="flex: 1;">
                <span class="ayar-etiket">Hedef Parametre</span>
                <nz-select nzSize="small" [(ngModel)]="bag.hedefParametre"
                           [ngModelOptions]="{standalone: true}" nzShowSearch nzPlaceHolder="Parametre secin"
                           (ngModelChange)="inlineAyarDegisti()">
                  @for (p of getParametreIsimleri(); track p.ismi) {
                    <nz-option [nzValue]="p.ismi" [nzLabel]="p.baslik"></nz-option>
                  }
                </nz-select>
              </div>
              <div class="ayar-alan" style="flex: 0.7;">
                <span class="ayar-etiket">Kosul</span>
                <nz-select nzSize="small" [(ngModel)]="bag.kosul"
                           [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">
                  <nz-option nzValue="esittir" nzLabel="Esittir"></nz-option>
                  <nz-option nzValue="esitDegil" nzLabel="Esit Degil"></nz-option>
                  <nz-option nzValue="iceriyor" nzLabel="Iceriyor"></nz-option>
                  <nz-option nzValue="bos" nzLabel="Bos"></nz-option>
                  <nz-option nzValue="bosDegil" nzLabel="Bos Degil"></nz-option>
                  <nz-option nzValue="buyuk" nzLabel="Buyuk"></nz-option>
                  <nz-option nzValue="kucuk" nzLabel="Kucuk"></nz-option>
                </nz-select>
              </div>
              <div class="ayar-alan" style="flex: 0.7;">
                <span class="ayar-etiket">Deger</span>
                <input nz-input nzSize="small" [(ngModel)]="bag.deger"
                       [ngModelOptions]="{standalone: true}" placeholder="Karsilastirma degeri"
                       (ngModelChange)="inlineAyarDegisti()" />
              </div>
              <div class="ayar-alan" style="flex: 0.6;">
                <span class="ayar-etiket">Aksiyon</span>
                <nz-select nzSize="small" [(ngModel)]="bag.aksiyon"
                           [ngModelOptions]="{standalone: true}" (ngModelChange)="inlineAyarDegisti()">
                  <nz-option nzValue="gorunur" nzLabel="Gorunur Yap"></nz-option>
                  <nz-option nzValue="gizle" nzLabel="Gizle"></nz-option>
                  <nz-option nzValue="zorunlu" nzLabel="Zorunlu Yap"></nz-option>
                  <nz-option nzValue="sadeceOkunur" nzLabel="Salt Okunur"></nz-option>
                  <nz-option nzValue="aktif" nzLabel="Aktif Yap"></nz-option>
                  <nz-option nzValue="deaktif" nzLabel="Deaktif Yap"></nz-option>
                </nz-select>
              </div>
              <div class="kontrol-aksiyonlar">
                <button nz-button nzSize="small" nzType="text" nzDanger
                        (click)="bagimlilikSil(itm, $index)">
                  <nz-icon nzType="delete" />
                </button>
              </div>
            </div>
          }
          @if (!itm.ayarlar?.bagimliliklar?.length) {
            <div class="ayar-bilgi">
              <span class="ayar-bilgi-metin">Henuz bagimlilik tanimlanmamis.</span>
            </div>
          }
        </div>
      </nz-tab>

      <!-- JSON -->
      <nz-tab nzTitle="JSON">
        <div class="ayar-grup">
          <div class="ayar-bilgi" style="margin-bottom: 6px;">
            <nz-tag nzColor="volcano">Ham Veri</nz-tag>
            <span class="ayar-bilgi-metin">Parametrenin ham JSON verisini goruntuleyin ve duzenleyin.</span>
          </div>
          <div class="ayar-alan">
            <textarea nz-input nzSize="small"
                      [ngModel]="getParametreJson(itm)"
                      [ngModelOptions]="{standalone: true}"
                      rows="12" class="kod-alani json-editor" placeholder="{}"
                      (ngModelChange)="jsonDanGuncelle(itm, $event, ayarModalIndex)"></textarea>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 8px;">
            <button nz-button nzSize="small" nzType="dashed" (click)="parametreyiPanoyaKopyala(itm)">
              <nz-icon nzType="copy" /> Panoya Kopyala
            </button>
            <button nz-button nzSize="small" nzType="dashed" (click)="parametreDisaAktarTekil(itm)">
              <nz-icon nzType="download" /> JSON Indir
            </button>
          </div>
        </div>
      </nz-tab>

    </nz-tabs>
  }
  </ng-container>
</nz-modal>
<ng-template #ayarModalFooterTpl>
  <button nz-button nzType="default" (click)="ayarModalKapat()">Kapat</button>
</ng-template>

<nz-modal [(nzVisible)]="sablonModalAcik" nzTitle="Parametre Şablonları" [nzWidth]="480" nzCentered [nzFooter]="null">
  <ng-container *nzModalContent>
    <div style="margin-bottom:12px;display:flex;gap:8px">
      <input nz-input [(ngModel)]="yeniSablonIsim" [ngModelOptions]="{standalone: true}" placeholder="Şablon ismi..." style="flex:1" />
      <button nz-button nzType="primary" [disabled]="!yeniSablonIsim?.trim() || !parametreler?.length" (click)="sablonKaydet()">Kaydet</button>
    </div>
    @if (sablonListesi.length) {
      <nz-list nzSize="small">
        @for (s of sablonListesi; track $index) {
          <nz-list-item>
            <nz-list-item-meta [nzTitle]="s.isim" [nzDescription]="s.parametreler.length + ' parametre · ' + (s.tarih | date:'short')"></nz-list-item-meta>
            <ul nz-list-item-actions>
              <nz-list-item-action><a (click)="sablonYukle(s)">Yükle</a></nz-list-item-action>
              <nz-list-item-action><a nz-popconfirm nzPopconfirmTitle="Silinsin mi?" (nzOnConfirm)="sablonSil($index)" style="color:#ff4d4f">Sil</a></nz-list-item-action>
            </ul>
          </nz-list-item>
        }
      </nz-list>
    } @else {
      <nz-empty nzNotFoundContent="Henüz şablon yok"></nz-empty>
    }
  </ng-container>
</nz-modal>

</form>